

// Generated by Typewriter.
// More info: http://frhagn.github.io/Typewriter/

// $Classes/Enums/Interfaces(filter)[template][separator]
// filter (optional): Matches the name or full name of the current item. * = match
// any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
// template: The template to repeat for each matched item
// separator (optional): A separator template that is placed between all templates
// e.g. $Properties[public $name: $Type][, ]

/* tslint:disable:no-inferrable-types*/




export interface ICompPlanListInq {

	SalesEntityID: number
	RelationshipTypeID: number
	ContractID: number
	PayFromContractInstanceID: number
	SalesEntityRecipientID: number
	StartPage: number
	MaxRows: number
}

export class CompPlanListInq implements ICompPlanListInq {

	SalesEntityID: number = null;
	RelationshipTypeID: number = null;
	ContractID: number = null;
	PayFromContractInstanceID: number = null;
	SalesEntityRecipientID: number = null;
	StartPage: number = null;
	MaxRows: number = null;

	constructor(src?: ICompPlanListInq) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.RelationshipTypeID = src.RelationshipTypeID;
			this.ContractID = src.ContractID;
			this.PayFromContractInstanceID = src.PayFromContractInstanceID;
			this.SalesEntityRecipientID = src.SalesEntityRecipientID;
			this.StartPage = src.StartPage;
			this.MaxRows = src.MaxRows;
		}
	}

}

export interface ICompPlan {

	CompPlanID: number
	SalesEntityRecipientID: number
	SalesEntityRecipientName: string
	RelationshipTypeID: number
	RelationshipTypeName: string
	ContractID: number
	ContractName: string
	ContractPercentage: number
	PoolPhase: number
	CalcFromCompPlanID: number
	PayFromCompPlanID: number
	TieringType: number
	PriceListID: number
	PriceListName: string
	CreatedDateTime: Date
	EffectiveStartDate: Date
	EffectiveEndDate: Date
	MerchantStartDate: Date
	MerchantEndDate: Date
	WriteAll: boolean
}

export class CompPlan implements ICompPlan {

	CompPlanID: number = 0;
	SalesEntityRecipientID: number = null;
	SalesEntityRecipientName: string = null;
	RelationshipTypeID: number = null;
	RelationshipTypeName: string = null;
	ContractID: number = null;
	ContractName: string = null;
	ContractPercentage: number = null;
	PoolPhase: number = null;
	CalcFromCompPlanID: number = null;
	PayFromCompPlanID: number = null;
	TieringType: number = null;
	PriceListID: number = null;
	PriceListName: string = null;
	CreatedDateTime: Date = null;
	EffectiveStartDate: Date = null;
	EffectiveEndDate: Date = null;
	MerchantStartDate: Date = null;
	MerchantEndDate: Date = null;
	WriteAll: boolean = null;

	constructor(src?: ICompPlan) {
		if (src) {
			this.CompPlanID = src.CompPlanID;
			this.SalesEntityRecipientID = src.SalesEntityRecipientID;
			this.SalesEntityRecipientName = src.SalesEntityRecipientName;
			this.RelationshipTypeID = src.RelationshipTypeID;
			this.RelationshipTypeName = src.RelationshipTypeName;
			this.ContractID = src.ContractID;
			this.ContractName = src.ContractName;
			this.ContractPercentage = src.ContractPercentage;
			this.PoolPhase = src.PoolPhase;
			this.CalcFromCompPlanID = src.CalcFromCompPlanID;
			this.PayFromCompPlanID = src.PayFromCompPlanID;
			this.TieringType = src.TieringType;
			this.PriceListID = src.PriceListID;
			this.PriceListName = src.PriceListName;
			this.CreatedDateTime = src.CreatedDateTime;
			this.EffectiveStartDate = src.EffectiveStartDate;
			this.EffectiveEndDate = src.EffectiveEndDate;
			this.MerchantStartDate = src.MerchantStartDate;
			this.MerchantEndDate = src.MerchantEndDate;
			this.WriteAll = src.WriteAll;
		}
	}

}

export interface IPayoutInstance {

	PayoutInstanceID: number
	SalesEntityID: number
	RelationshipTypeID: number
	CompPlanID: number
	ReferenceID: number
	MerchantNumber: number
	ContractPercentage: number
	IsNet: boolean
	EffectivePercentage: number
	PayFromCompPlanID: number
	CreatedDateTime: Date
	RowAppUserID: number
}

export class PayoutInstance implements IPayoutInstance {

	PayoutInstanceID: number = null;
	SalesEntityID: number = null;
	RelationshipTypeID: number = null;
	CompPlanID: number = null;
	ReferenceID: number = null;
	MerchantNumber: number = null;
	ContractPercentage: number = null;
	IsNet: boolean = null;
	EffectivePercentage: number = null;
	PayFromCompPlanID: number = null;
	CreatedDateTime: Date = null;
	RowAppUserID: number = null;

	constructor(src?: IPayoutInstance) {
		if (src) {
			this.PayoutInstanceID = src.PayoutInstanceID;
			this.SalesEntityID = src.SalesEntityID;
			this.RelationshipTypeID = src.RelationshipTypeID;
			this.CompPlanID = src.CompPlanID;
			this.ReferenceID = src.ReferenceID;
			this.MerchantNumber = src.MerchantNumber;
			this.ContractPercentage = src.ContractPercentage;
			this.IsNet = src.IsNet;
			this.EffectivePercentage = src.EffectivePercentage;
			this.PayFromCompPlanID = src.PayFromCompPlanID;
			this.CreatedDateTime = src.CreatedDateTime;
			this.RowAppUserID = src.RowAppUserID;
		}
	}

}

export interface IPayoutInstanceListInquiry {

	SalesEntityID: number
	RelationshipTypeID: number
	CompPlanID: number
	ReferenceID: number
	PayFromCompPlanID: number
}

export class PayoutInstanceListInquiry implements IPayoutInstanceListInquiry {

	SalesEntityID: number = null;
	RelationshipTypeID: number = null;
	CompPlanID: number = null;
	ReferenceID: number = null;
	PayFromCompPlanID: number = null;

	constructor(src?: IPayoutInstanceListInquiry) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.RelationshipTypeID = src.RelationshipTypeID;
			this.CompPlanID = src.CompPlanID;
			this.ReferenceID = src.ReferenceID;
			this.PayFromCompPlanID = src.PayFromCompPlanID;
		}
	}

}

export interface IPayoutProgram {

	PayoutProgramID: number
	SalesEntityID: number
	RelationshipTypeID: number
	CompPlanID: number
	ContractPercentage: number
	IsNet: boolean
	PayFromCompPlanID: number
	CreatedDateTime: Date
	RowAppUserID: number
}

export class PayoutProgram implements IPayoutProgram {

	PayoutProgramID: number = null;
	SalesEntityID: number = null;
	RelationshipTypeID: number = null;
	CompPlanID: number = null;
	ContractPercentage: number = null;
	IsNet: boolean = null;
	PayFromCompPlanID: number = null;
	CreatedDateTime: Date = null;
	RowAppUserID: number = null;

	constructor(src?: IPayoutProgram) {
		if (src) {
			this.PayoutProgramID = src.PayoutProgramID;
			this.SalesEntityID = src.SalesEntityID;
			this.RelationshipTypeID = src.RelationshipTypeID;
			this.CompPlanID = src.CompPlanID;
			this.ContractPercentage = src.ContractPercentage;
			this.IsNet = src.IsNet;
			this.PayFromCompPlanID = src.PayFromCompPlanID;
			this.CreatedDateTime = src.CreatedDateTime;
			this.RowAppUserID = src.RowAppUserID;
		}
	}

}

export interface IPayoutProgramListInquiry {

	SalesEntityID: number
	RelationshipTypeID: number
	CompPlanID: number
	PayFromCompPlanID: number
}

export class PayoutProgramListInquiry implements IPayoutProgramListInquiry {

	SalesEntityID: number = null;
	RelationshipTypeID: number = null;
	CompPlanID: number = null;
	PayFromCompPlanID: number = null;

	constructor(src?: IPayoutProgramListInquiry) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.RelationshipTypeID = src.RelationshipTypeID;
			this.CompPlanID = src.CompPlanID;
			this.PayFromCompPlanID = src.PayFromCompPlanID;
		}
	}

}

export interface IBoardTargets {

	SalesEntityID: number
	Name: string
}

export class BoardTargets implements IBoardTargets {

	SalesEntityID: number = 0;
	Name: string = null;

	constructor(src?: IBoardTargets) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.Name = src.Name;
		}
	}

}

export interface IResultPaging {

	StartPage: number
	MaxRows: number
}

export class ResultPaging implements IResultPaging {

	StartPage: number = null;
	MaxRows: number = null;

	constructor(src?: IResultPaging) {
		if (src) {
			this.StartPage = src.StartPage;
			this.MaxRows = src.MaxRows;
		}
	}

}

export interface ISalesEntityListInquiry {

	StartPage: number
	MaxRows: number
	SalesEntityParentID: number
	SystemID: number
	InstitutionID: number
	AssociationID: number
	SalesRepID: number
	ChainID: number
	RelationshipManagerID: number
	RelationshipDeveloperID: number
	BusinessDeveloperID: number
	AlliancePartner_ID: number
	SalesEntityID: number
	Search: string
}

export class SalesEntityListInquiry implements ISalesEntityListInquiry {

	StartPage: number = null;
	MaxRows: number = null;
	SalesEntityParentID: number = null;
	SystemID: number = null;
	InstitutionID: number = null;
	AssociationID: number = null;
	SalesRepID: number = null;
	ChainID: number = null;
	RelationshipManagerID: number = null;
	RelationshipDeveloperID: number = null;
	BusinessDeveloperID: number = null;
	AlliancePartner_ID: number = null;
	SalesEntityID: number = null;
	Search: string = null;

	constructor(src?: ISalesEntityListInquiry) {
		if (src) {
			this.StartPage = src.StartPage;
			this.MaxRows = src.MaxRows;
			this.SalesEntityParentID = src.SalesEntityParentID;
			this.SystemID = src.SystemID;
			this.InstitutionID = src.InstitutionID;
			this.AssociationID = src.AssociationID;
			this.SalesRepID = src.SalesRepID;
			this.ChainID = src.ChainID;
			this.RelationshipManagerID = src.RelationshipManagerID;
			this.RelationshipDeveloperID = src.RelationshipDeveloperID;
			this.BusinessDeveloperID = src.BusinessDeveloperID;
			this.AlliancePartner_ID = src.AlliancePartner_ID;
			this.SalesEntityID = src.SalesEntityID;
			this.Search = src.Search;
		}
	}

}

export interface IBoardTargetsList {

	ISOID: number
	ISOIDList: string
	BT: BoardTargets[]
	BoardOk: BoardTargets[]
	FilterRequired: boolean
}

export class BoardTargetsList implements IBoardTargetsList {

	ISOID: number = 0;
	ISOIDList: string = null;
	BT: BoardTargets[] = [];
	BoardOk: BoardTargets[] = [];
	FilterRequired: boolean = false;

	constructor(src?: IBoardTargetsList) {
		if (src) {
			this.ISOID = src.ISOID;
			this.ISOIDList = src.ISOIDList;
			this.BT = src.BT;
			this.BoardOk = src.BoardOk;
			this.FilterRequired = src.FilterRequired;
		}
	}

}

export interface ISalesEntityView {

	SalesEntity: SalesEntityModel
	Sys: SystemModel
	Institution: Institution
	Association: Association
	SalesRep: SalesRep
	Chain: Chain
	AlliancePartner: AlliancePartner
}

export class SalesEntityView implements ISalesEntityView {

	SalesEntity: SalesEntityModel = null;
	Sys: SystemModel = null;
	Institution: Institution = null;
	Association: Association = null;
	SalesRep: SalesRep = null;
	Chain: Chain = null;
	AlliancePartner: AlliancePartner = null;

	constructor(src?: ISalesEntityView) {
		if (src) {
			this.SalesEntity = src.SalesEntity;
			this.Sys = src.Sys;
			this.Institution = src.Institution;
			this.Association = src.Association;
			this.SalesRep = src.SalesRep;
			this.Chain = src.Chain;
			this.AlliancePartner = src.AlliancePartner;
		}
	}

}

export interface ISalesEntityModelList {

	TotalRows: number
	BreadCrumbs: SalesUserBreadcrumbs[]
	SalesEntities: SalesEntityModel[]
}

export class SalesEntityModelList implements ISalesEntityModelList {

	TotalRows: number = 0;
	BreadCrumbs: SalesUserBreadcrumbs[] = [];
	SalesEntities: SalesEntityModel[] = [];

	constructor(src?: ISalesEntityModelList) {
		if (src) {
			this.TotalRows = src.TotalRows;
			this.BreadCrumbs = src.BreadCrumbs;
			this.SalesEntities = src.SalesEntities;
		}
	}

}

export interface ISEListItemResponse {

	SalesEntities: SEListItem[]
	BreadCrumbs: SalesUserBreadcrumbs[]
}

export class SEListItemResponse implements ISEListItemResponse {

	SalesEntities: SEListItem[] = [];
	BreadCrumbs: SalesUserBreadcrumbs[] = [];

	constructor(src?: ISEListItemResponse) {
		if (src) {
			this.SalesEntities = src.SalesEntities;
			this.BreadCrumbs = src.BreadCrumbs;
		}
	}

}

export interface ISEListItem {

	SalesEntityID: number
	SalesEntityParentID: number
	Name: string
	ISONumber: string
	Regions: string
	ChildCount: number
	EntityTypeID: number
}

export class SEListItem implements ISEListItem {

	SalesEntityID: number = 0;
	SalesEntityParentID: number = null;
	Name: string = null;
	ISONumber: string = null;
	Regions: string = null;
	ChildCount: number = 0;
	EntityTypeID: number = null;

	constructor(src?: ISEListItem) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.SalesEntityParentID = src.SalesEntityParentID;
			this.Name = src.Name;
			this.ISONumber = src.ISONumber;
			this.Regions = src.Regions;
			this.ChildCount = src.ChildCount;
			this.EntityTypeID = src.EntityTypeID;
		}
	}

}

export interface ISalesEntityModel {

	SalesEntityID: number
	SalesEntityParentID: number
	Name: string
	Telephone: string
	Email: string
	TaxIDNumber: string
	BankAccountHolder: string
	BankAccountBankName: string
	BankAccountNumber: string
	BankAccountRoutingNumber: string
	SystemID: number
	InstitutionID: number
	AssociationID: number
	SalesRepID: number
	ChainID: number
	RelationshipManagerID: number
	RelationshipDeveloperID: number
	BusinessDeveloperID: number
	CreatedDateTime: Date
	RowAppUSerID: number
	AlliancePartner_ID: number
	ISONumber: string
	ChildCount: number
	MerchantCount: number
	AllMerchantCount: number
	EntityTypeDescription: string
	ChannelDescription: string
	StatusDescription: string
	EntityTypeID: number
	StatusID: number
	VendorID: string
	TaxStatus: string
	NegativeResiduals: string
	ChannelID: number
	WriteAll: boolean
	IsApproved: boolean
	Regions: string
	CRMInstanceID: number
	CRMUserID: string
	SEBoardingHierarchy: SalesEntityBoardingHierarchy[]
}

export class SalesEntityModel implements ISalesEntityModel {

	SalesEntityID: number = null;
	SalesEntityParentID: number = null;
	Name: string = null;
	Telephone: string = null;
	Email: string = null;
	TaxIDNumber: string = null;
	BankAccountHolder: string = null;
	BankAccountBankName: string = null;
	BankAccountNumber: string = null;
	BankAccountRoutingNumber: string = null;
	SystemID: number = null;
	InstitutionID: number = null;
	AssociationID: number = null;
	SalesRepID: number = null;
	ChainID: number = null;
	RelationshipManagerID: number = null;
	RelationshipDeveloperID: number = null;
	BusinessDeveloperID: number = null;
	CreatedDateTime: Date = null;
	RowAppUSerID: number = null;
	AlliancePartner_ID: number = null;
	ISONumber: string = null;
	ChildCount: number = 0;
	MerchantCount: number = 0;
	AllMerchantCount: number = 0;
	EntityTypeDescription: string = null;
	ChannelDescription: string = null;
	StatusDescription: string = null;
	EntityTypeID: number = null;
	StatusID: number = null;
	VendorID: string = null;
	TaxStatus: string = null;
	NegativeResiduals: string = null;
	ChannelID: number = null;
	WriteAll: boolean = null;
	IsApproved: boolean = null;
	Regions: string = null;
	CRMInstanceID: number = null;
	CRMUserID: string = null;
	SEBoardingHierarchy: SalesEntityBoardingHierarchy[] = [];

	constructor(src?: ISalesEntityModel) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.SalesEntityParentID = src.SalesEntityParentID;
			this.Name = src.Name;
			this.Telephone = src.Telephone;
			this.Email = src.Email;
			this.TaxIDNumber = src.TaxIDNumber;
			this.BankAccountHolder = src.BankAccountHolder;
			this.BankAccountBankName = src.BankAccountBankName;
			this.BankAccountNumber = src.BankAccountNumber;
			this.BankAccountRoutingNumber = src.BankAccountRoutingNumber;
			this.SystemID = src.SystemID;
			this.InstitutionID = src.InstitutionID;
			this.AssociationID = src.AssociationID;
			this.SalesRepID = src.SalesRepID;
			this.ChainID = src.ChainID;
			this.RelationshipManagerID = src.RelationshipManagerID;
			this.RelationshipDeveloperID = src.RelationshipDeveloperID;
			this.BusinessDeveloperID = src.BusinessDeveloperID;
			this.CreatedDateTime = src.CreatedDateTime;
			this.RowAppUSerID = src.RowAppUSerID;
			this.AlliancePartner_ID = src.AlliancePartner_ID;
			this.ISONumber = src.ISONumber;
			this.ChildCount = src.ChildCount;
			this.MerchantCount = src.MerchantCount;
			this.AllMerchantCount = src.AllMerchantCount;
			this.EntityTypeDescription = src.EntityTypeDescription;
			this.ChannelDescription = src.ChannelDescription;
			this.StatusDescription = src.StatusDescription;
			this.EntityTypeID = src.EntityTypeID;
			this.StatusID = src.StatusID;
			this.VendorID = src.VendorID;
			this.TaxStatus = src.TaxStatus;
			this.NegativeResiduals = src.NegativeResiduals;
			this.ChannelID = src.ChannelID;
			this.WriteAll = src.WriteAll;
			this.IsApproved = src.IsApproved;
			this.Regions = src.Regions;
			this.CRMInstanceID = src.CRMInstanceID;
			this.CRMUserID = src.CRMUserID;
			this.SEBoardingHierarchy = src.SEBoardingHierarchy;
		}
	}

}

export interface ISalesEntityBoardingHierarchy {

	SalesEntityID: number
	BoardingHierarchyLabel: string
	DefaultTF: boolean
}

export class SalesEntityBoardingHierarchy implements ISalesEntityBoardingHierarchy {

	SalesEntityID: number = 0;
	BoardingHierarchyLabel: string = null;
	DefaultTF: boolean = false;

	constructor(src?: ISalesEntityBoardingHierarchy) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.BoardingHierarchyLabel = src.BoardingHierarchyLabel;
			this.DefaultTF = src.DefaultTF;
		}
	}

}

export interface ISalesEntityBoardingHierarchyNew {

	SalesEntityID: number
	SystemID: number
	InstitutionID: number
	AssociationID: number
	SalesRepID: number
	ChainID: number
	Default: boolean
	USerID: number
}

export class SalesEntityBoardingHierarchyNew implements ISalesEntityBoardingHierarchyNew {

	SalesEntityID: number = 0;
	SystemID: number = null;
	InstitutionID: number = null;
	AssociationID: number = null;
	SalesRepID: number = null;
	ChainID: number = null;
	Default: boolean = null;
	USerID: number = null;

	constructor(src?: ISalesEntityBoardingHierarchyNew) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.SystemID = src.SystemID;
			this.InstitutionID = src.InstitutionID;
			this.AssociationID = src.AssociationID;
			this.SalesRepID = src.SalesRepID;
			this.ChainID = src.ChainID;
			this.Default = src.Default;
			this.USerID = src.USerID;
		}
	}

}

export interface ISystemModel {

	SystemID: number
	SystemNumber: number
	SystemDescription: string
}

export class SystemModel implements ISystemModel {

	SystemID: number = 0;
	SystemNumber: number = 0;
	SystemDescription: string = null;

	constructor(src?: ISystemModel) {
		if (src) {
			this.SystemID = src.SystemID;
			this.SystemNumber = src.SystemNumber;
			this.SystemDescription = src.SystemDescription;
		}
	}

}

export interface IInstitution {

	InstitutionID: number
	SystemID: number
	InstitutionNumber: number
	InstitutionDescription: string
}

export class Institution implements IInstitution {

	InstitutionID: number = 0;
	SystemID: number = 0;
	InstitutionNumber: number = 0;
	InstitutionDescription: string = null;

	constructor(src?: IInstitution) {
		if (src) {
			this.InstitutionID = src.InstitutionID;
			this.SystemID = src.SystemID;
			this.InstitutionNumber = src.InstitutionNumber;
			this.InstitutionDescription = src.InstitutionDescription;
		}
	}

}

export interface IAssociation {

	AssociationID: number
	SystemID: number
	InstitutionID: number
	AssociationNumber: number
	AssociationDescription: string
}

export class Association implements IAssociation {

	AssociationID: number = 0;
	SystemID: number = 0;
	InstitutionID: number = 0;
	AssociationNumber: number = 0;
	AssociationDescription: string = null;

	constructor(src?: IAssociation) {
		if (src) {
			this.AssociationID = src.AssociationID;
			this.SystemID = src.SystemID;
			this.InstitutionID = src.InstitutionID;
			this.AssociationNumber = src.AssociationNumber;
			this.AssociationDescription = src.AssociationDescription;
		}
	}

}

export interface ISalesRep {

	SalesRepID: number
	SystemID: number
	AssociationID: number
	InstitutionID: number
	SalesRepNumber: number
	SalesRepDescription: string
}

export class SalesRep implements ISalesRep {

	SalesRepID: number = 0;
	SystemID: number = 0;
	AssociationID: number = 0;
	InstitutionID: number = 0;
	SalesRepNumber: number = 0;
	SalesRepDescription: string = null;

	constructor(src?: ISalesRep) {
		if (src) {
			this.SalesRepID = src.SalesRepID;
			this.SystemID = src.SystemID;
			this.AssociationID = src.AssociationID;
			this.InstitutionID = src.InstitutionID;
			this.SalesRepNumber = src.SalesRepNumber;
			this.SalesRepDescription = src.SalesRepDescription;
		}
	}

}

export interface IChain {

	ChainID: number
	SystemID: number
	AssociationID: number
	SalesRepID: number
	InstitutionID: number
	ChainNumber: number
	ChainDescription: string
}

export class Chain implements IChain {

	ChainID: number = 0;
	SystemID: number = 0;
	AssociationID: number = 0;
	SalesRepID: number = 0;
	InstitutionID: number = 0;
	ChainNumber: number = 0;
	ChainDescription: string = null;

	constructor(src?: IChain) {
		if (src) {
			this.ChainID = src.ChainID;
			this.SystemID = src.SystemID;
			this.AssociationID = src.AssociationID;
			this.SalesRepID = src.SalesRepID;
			this.InstitutionID = src.InstitutionID;
			this.ChainNumber = src.ChainNumber;
			this.ChainDescription = src.ChainDescription;
		}
	}

}

export interface IAlliancePartner {

	AlliancePartnerID: number
	AlliancePartnerDescription: string
	ContactPhone: string
}

export class AlliancePartner implements IAlliancePartner {

	AlliancePartnerID: number = 0;
	AlliancePartnerDescription: string = null;
	ContactPhone: string = null;

	constructor(src?: IAlliancePartner) {
		if (src) {
			this.AlliancePartnerID = src.AlliancePartnerID;
			this.AlliancePartnerDescription = src.AlliancePartnerDescription;
			this.ContactPhone = src.ContactPhone;
		}
	}

}

export interface ISalesEntityAddress {

	AddressID: number
	SalesEntityID: number
	AddressTypeID: string
	FirstName: string
	LastName: string
	Department: string
	AddressLine1: string
	AddressLine2: string
	City: string
	State: string
	Zip: string
	Label: string
	WriteAll: boolean
	CreatedDateTime: Date
}

export class SalesEntityAddress implements ISalesEntityAddress {

	AddressID: number = null;
	SalesEntityID: number = null;
	AddressTypeID: string = null;
	FirstName: string = null;
	LastName: string = null;
	Department: string = null;
	AddressLine1: string = null;
	AddressLine2: string = null;
	City: string = null;
	State: string = null;
	Zip: string = null;
	Label: string = null;
	WriteAll: boolean = null;
	CreatedDateTime: Date = null;

	constructor(src?: ISalesEntityAddress) {
		if (src) {
			this.AddressID = src.AddressID;
			this.SalesEntityID = src.SalesEntityID;
			this.AddressTypeID = src.AddressTypeID;
			this.FirstName = src.FirstName;
			this.LastName = src.LastName;
			this.Department = src.Department;
			this.AddressLine1 = src.AddressLine1;
			this.AddressLine2 = src.AddressLine2;
			this.City = src.City;
			this.State = src.State;
			this.Zip = src.Zip;
			this.Label = src.Label;
			this.WriteAll = src.WriteAll;
			this.CreatedDateTime = src.CreatedDateTime;
		}
	}

}

export interface ISalesEntityContact {

	SalesEntityID: number
	ContactID: number
	FirstName: string
	LastName: string
	Email: string
	Telephone: string
	Mobile: string
	Fax: string
	IsActive: boolean
	IsDefault: boolean
	Title: string
	CreatedDateTime: Date
	WriteAll: boolean
}

export class SalesEntityContact implements ISalesEntityContact {

	SalesEntityID: number = null;
	ContactID: number = null;
	FirstName: string = null;
	LastName: string = null;
	Email: string = null;
	Telephone: string = null;
	Mobile: string = null;
	Fax: string = null;
	IsActive: boolean = null;
	IsDefault: boolean = null;
	Title: string = null;
	CreatedDateTime: Date = new Date(0);
	WriteAll: boolean = null;

	constructor(src?: ISalesEntityContact) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.ContactID = src.ContactID;
			this.FirstName = src.FirstName;
			this.LastName = src.LastName;
			this.Email = src.Email;
			this.Telephone = src.Telephone;
			this.Mobile = src.Mobile;
			this.Fax = src.Fax;
			this.IsActive = src.IsActive;
			this.IsDefault = src.IsDefault;
			this.Title = src.Title;
			this.CreatedDateTime = src.CreatedDateTime;
			this.WriteAll = src.WriteAll;
		}
	}

}

export interface ISalesUserInquiry {

	UserRoleID: number
	LastBoardSalesEntityID: number
	DefaultSalesEntityID: number
}

export class SalesUserInquiry implements ISalesUserInquiry {

	UserRoleID: number = null;
	LastBoardSalesEntityID: number = null;
	DefaultSalesEntityID: number = null;

	constructor(src?: ISalesUserInquiry) {
		if (src) {
			this.UserRoleID = src.UserRoleID;
			this.LastBoardSalesEntityID = src.LastBoardSalesEntityID;
			this.DefaultSalesEntityID = src.DefaultSalesEntityID;
		}
	}

}

export interface ISalesUser {

	UserID: number
	UserRoleID: number
	LastBoardSalesEntityID: number
	DefaultSalesEntityID: number
	CreatedDateTime: Date
	RowAppUserID: number
}

export class SalesUser implements ISalesUser {

	UserID: number = null;
	UserRoleID: number = null;
	LastBoardSalesEntityID: number = null;
	DefaultSalesEntityID: number = null;
	CreatedDateTime: Date = null;
	RowAppUserID: number = null;

	constructor(src?: ISalesUser) {
		if (src) {
			this.UserID = src.UserID;
			this.UserRoleID = src.UserRoleID;
			this.LastBoardSalesEntityID = src.LastBoardSalesEntityID;
			this.DefaultSalesEntityID = src.DefaultSalesEntityID;
			this.CreatedDateTime = src.CreatedDateTime;
			this.RowAppUserID = src.RowAppUserID;
		}
	}

}

export interface ISalesUserAccess {

	UserID: number
	SalesEntityID: number
	Name: string
	AllowBoarding: boolean
	IncludeChildren: boolean
	CreatedDateTime: Date
	AdminUserID: number
}

export class SalesUserAccess implements ISalesUserAccess {

	UserID: number = 0;
	SalesEntityID: number = 0;
	Name: string = null;
	AllowBoarding: boolean = false;
	IncludeChildren: boolean = false;
	CreatedDateTime: Date = null;
	AdminUserID: number = null;

	constructor(src?: ISalesUserAccess) {
		if (src) {
			this.UserID = src.UserID;
			this.SalesEntityID = src.SalesEntityID;
			this.Name = src.Name;
			this.AllowBoarding = src.AllowBoarding;
			this.IncludeChildren = src.IncludeChildren;
			this.CreatedDateTime = src.CreatedDateTime;
			this.AdminUserID = src.AdminUserID;
		}
	}

}

export interface IHATEOASLink {

	href: string
	rel: string
	method: string
}

export class HATEOASLink implements IHATEOASLink {

	href: string = null;
	rel: string = null;
	method: string = null;

	constructor(src?: IHATEOASLink) {
		if (src) {
			this.href = src.href;
			this.rel = src.rel;
			this.method = src.method;
		}
	}

}

export interface IHierarchyType {

	HierarchyTypeID: number
	AlliancePartnerID: number
	Name: string
	CalcSourceTypeID: string
	CalcSourceHierarchyTypeID: number
	PaySourceTypeID: string
	PaySourceHierarchyTypeID: number
	MinimumPercent: number
	MaximumPercent: number
	ReportingTypeID: string
	AlertEligible: boolean
	CreatedDateTime: Date
	RowAppUserID: number
}

export class HierarchyType implements IHierarchyType {

	HierarchyTypeID: number = null;
	AlliancePartnerID: number = null;
	Name: string = null;
	CalcSourceTypeID: string = null;
	CalcSourceHierarchyTypeID: number = null;
	PaySourceTypeID: string = null;
	PaySourceHierarchyTypeID: number = null;
	MinimumPercent: number = null;
	MaximumPercent: number = null;
	ReportingTypeID: string = null;
	AlertEligible: boolean = null;
	CreatedDateTime: Date = null;
	RowAppUserID: number = null;

	constructor(src?: IHierarchyType) {
		if (src) {
			this.HierarchyTypeID = src.HierarchyTypeID;
			this.AlliancePartnerID = src.AlliancePartnerID;
			this.Name = src.Name;
			this.CalcSourceTypeID = src.CalcSourceTypeID;
			this.CalcSourceHierarchyTypeID = src.CalcSourceHierarchyTypeID;
			this.PaySourceTypeID = src.PaySourceTypeID;
			this.PaySourceHierarchyTypeID = src.PaySourceHierarchyTypeID;
			this.MinimumPercent = src.MinimumPercent;
			this.MaximumPercent = src.MaximumPercent;
			this.ReportingTypeID = src.ReportingTypeID;
			this.AlertEligible = src.AlertEligible;
			this.CreatedDateTime = src.CreatedDateTime;
			this.RowAppUserID = src.RowAppUserID;
		}
	}

}

export interface IHierarchyInq {

	AlliancePartnerID: number
	CalcSourceTypeID: string
	CalcSourceHierarchyTypeID: number
	PaySourceTypeID: string
	PaySourceHierarchyTypeID: number
	ReportingTypeID: string
}

export class HierarchyInq implements IHierarchyInq {

	AlliancePartnerID: number = null;
	CalcSourceTypeID: string = null;
	CalcSourceHierarchyTypeID: number = null;
	PaySourceTypeID: string = null;
	PaySourceHierarchyTypeID: number = null;
	ReportingTypeID: string = null;

	constructor(src?: IHierarchyInq) {
		if (src) {
			this.AlliancePartnerID = src.AlliancePartnerID;
			this.CalcSourceTypeID = src.CalcSourceTypeID;
			this.CalcSourceHierarchyTypeID = src.CalcSourceHierarchyTypeID;
			this.PaySourceTypeID = src.PaySourceTypeID;
			this.PaySourceHierarchyTypeID = src.PaySourceHierarchyTypeID;
			this.ReportingTypeID = src.ReportingTypeID;
		}
	}

}

export interface IRelationshipType {

	RelationshipTypeID: number
	AlliancePartnerID: number
	RelationshipTypeName: string
	DefaultPercentage: number
	CreatedDateTime: Date
	RowSystemUser: string
	RowAppUserID: number
	RowStartTime: Date
	RowEndTime: Date
}

export class RelationshipType implements IRelationshipType {

	RelationshipTypeID: number = null;
	AlliancePartnerID: number = null;
	RelationshipTypeName: string = null;
	DefaultPercentage: number = null;
	CreatedDateTime: Date = null;
	RowSystemUser: string = null;
	RowAppUserID: number = null;
	RowStartTime: Date = null;
	RowEndTime: Date = null;

	constructor(src?: IRelationshipType) {
		if (src) {
			this.RelationshipTypeID = src.RelationshipTypeID;
			this.AlliancePartnerID = src.AlliancePartnerID;
			this.RelationshipTypeName = src.RelationshipTypeName;
			this.DefaultPercentage = src.DefaultPercentage;
			this.CreatedDateTime = src.CreatedDateTime;
			this.RowSystemUser = src.RowSystemUser;
			this.RowAppUserID = src.RowAppUserID;
			this.RowStartTime = src.RowStartTime;
			this.RowEndTime = src.RowEndTime;
		}
	}

}

export interface IRelationshipTypeEnforced {

	RootSalesEntityID: number
	CalcFromRelationshipTypeID: number
	CalcFromRelationshipTypeName: string
	PayFromRelationshipTypeID: number
	PayFromRelationshipTypeName: string
	GrantedRoleID: number
	GrantedRoleName: string
	PoolPhase: number
}

export class RelationshipTypeEnforced implements IRelationshipTypeEnforced {

	RootSalesEntityID: number = 0;
	CalcFromRelationshipTypeID: number = null;
	CalcFromRelationshipTypeName: string = null;
	PayFromRelationshipTypeID: number = null;
	PayFromRelationshipTypeName: string = null;
	GrantedRoleID: number = null;
	GrantedRoleName: string = null;
	PoolPhase: number = 0;

	constructor(src?: IRelationshipTypeEnforced) {
		if (src) {
			this.RootSalesEntityID = src.RootSalesEntityID;
			this.CalcFromRelationshipTypeID = src.CalcFromRelationshipTypeID;
			this.CalcFromRelationshipTypeName = src.CalcFromRelationshipTypeName;
			this.PayFromRelationshipTypeID = src.PayFromRelationshipTypeID;
			this.PayFromRelationshipTypeName = src.PayFromRelationshipTypeName;
			this.GrantedRoleID = src.GrantedRoleID;
			this.GrantedRoleName = src.GrantedRoleName;
			this.PoolPhase = src.PoolPhase;
		}
	}

}

export interface IRelationshipTypeRoot {

	RootSalesEntityID: number
	Name: string
}

export class RelationshipTypeRoot implements IRelationshipTypeRoot {

	RootSalesEntityID: number = 0;
	Name: string = null;

	constructor(src?: IRelationshipTypeRoot) {
		if (src) {
			this.RootSalesEntityID = src.RootSalesEntityID;
			this.Name = src.Name;
		}
	}

}

export interface IReportingType {

	ReportingTypeID: string
	ReportingTypeDescription: string
}

export class ReportingType implements IReportingType {

	ReportingTypeID: string = null;
	ReportingTypeDescription: string = null;

	constructor(src?: IReportingType) {
		if (src) {
			this.ReportingTypeID = src.ReportingTypeID;
			this.ReportingTypeDescription = src.ReportingTypeDescription;
		}
	}

}

export interface ISourceType {

	SourceTypeID: string
	SourceTypeDescription: string
}

export class SourceType implements ISourceType {

	SourceTypeID: string = null;
	SourceTypeDescription: string = null;

	constructor(src?: ISourceType) {
		if (src) {
			this.SourceTypeID = src.SourceTypeID;
			this.SourceTypeDescription = src.SourceTypeDescription;
		}
	}

}

export interface IUserRole {

	UserRoleID: number
	RoleName: string
}

export class UserRole implements IUserRole {

	UserRoleID: number = null;
	RoleName: string = null;

	constructor(src?: IUserRole) {
		if (src) {
			this.UserRoleID = src.UserRoleID;
			this.RoleName = src.RoleName;
		}
	}

}

export interface ISalesUserBreadcrumbs {

	TopLevelID: number
	DirectParentID: number
	TopLevelName: string
	DirectParentName: string
	CurrentID: number
	CurrentName: string
	TopLevelType: number
	DirectParentType: number
}

export class SalesUserBreadcrumbs implements ISalesUserBreadcrumbs {

	TopLevelID: number = null;
	DirectParentID: number = null;
	TopLevelName: string = null;
	DirectParentName: string = null;
	CurrentID: number = null;
	CurrentName: string = null;
	TopLevelType: number = null;
	DirectParentType: number = null;

	constructor(src?: ISalesUserBreadcrumbs) {
		if (src) {
			this.TopLevelID = src.TopLevelID;
			this.DirectParentID = src.DirectParentID;
			this.TopLevelName = src.TopLevelName;
			this.DirectParentName = src.DirectParentName;
			this.CurrentID = src.CurrentID;
			this.CurrentName = src.CurrentName;
			this.TopLevelType = src.TopLevelType;
			this.DirectParentType = src.DirectParentType;
		}
	}

}

export interface IMerchantAddressInfo {

	AddressType: string
	Name: string
	Addr1: string
	Addr2: string
	Addr3: string
	City: string
	State: string
	PostCode: string
	Country: string
}

export class MerchantAddressInfo implements IMerchantAddressInfo {

	AddressType: string = null;
	Name: string = null;
	Addr1: string = null;
	Addr2: string = null;
	Addr3: string = null;
	City: string = null;
	State: string = null;
	PostCode: string = null;
	Country: string = null;

	constructor(src?: IMerchantAddressInfo) {
		if (src) {
			this.AddressType = src.AddressType;
			this.Name = src.Name;
			this.Addr1 = src.Addr1;
			this.Addr2 = src.Addr2;
			this.Addr3 = src.Addr3;
			this.City = src.City;
			this.State = src.State;
			this.PostCode = src.PostCode;
			this.Country = src.Country;
		}
	}

}

export interface IMerchantPhoneNumbers {

	PhoneType: string
	PhoneNumber: string
}

export class MerchantPhoneNumbers implements IMerchantPhoneNumbers {

	PhoneType: string = null;
	PhoneNumber: string = null;

	constructor(src?: IMerchantPhoneNumbers) {
		if (src) {
			this.PhoneType = src.PhoneType;
			this.PhoneNumber = src.PhoneNumber;
		}
	}

}

export interface IMerchantSearch {

	StartPage: number
	MaxRows: number
	SystemID: number
	InstitutionID: number
	AssociationID: number
	SalesRepID: number
	ChainID: number
	AlliancePartnerID: number
	ISO_ID: number
	Search: string
	IncludeChildren: boolean
	MerchantOpen: string
	MerchantActive: string
	PCICompliant: string
	SalesEntityID: number
	SortBy: string
	SortOrder: string
}

export class MerchantSearch implements IMerchantSearch {

	StartPage: number = null;
	MaxRows: number = null;
	SystemID: number = null;
	InstitutionID: number = null;
	AssociationID: number = null;
	SalesRepID: number = null;
	ChainID: number = null;
	AlliancePartnerID: number = null;
	ISO_ID: number = null;
	Search: string = null;
	IncludeChildren: boolean = null;
	MerchantOpen: string = null;
	MerchantActive: string = null;
	PCICompliant: string = null;
	SalesEntityID: number = null;
	SortBy: string = null;
	SortOrder: string = null;

	constructor(src?: IMerchantSearch) {
		if (src) {
			this.StartPage = src.StartPage;
			this.MaxRows = src.MaxRows;
			this.SystemID = src.SystemID;
			this.InstitutionID = src.InstitutionID;
			this.AssociationID = src.AssociationID;
			this.SalesRepID = src.SalesRepID;
			this.ChainID = src.ChainID;
			this.AlliancePartnerID = src.AlliancePartnerID;
			this.ISO_ID = src.ISO_ID;
			this.Search = src.Search;
			this.IncludeChildren = src.IncludeChildren;
			this.MerchantOpen = src.MerchantOpen;
			this.MerchantActive = src.MerchantActive;
			this.PCICompliant = src.PCICompliant;
			this.SalesEntityID = src.SalesEntityID;
			this.SortBy = src.SortBy;
			this.SortOrder = src.SortOrder;
		}
	}

}

export interface IMerchantListPaging {

	MerchList: MerchantList[]
	TotalRows: number
}

export class MerchantListPaging implements IMerchantListPaging {

	MerchList: MerchantList[] = [];
	TotalRows: number = 0;

	constructor(src?: IMerchantListPaging) {
		if (src) {
			this.MerchList = src.MerchList;
			this.TotalRows = src.TotalRows;
		}
	}

}

export interface IMerchantList {

	MerchantNumber: number
	SystemID: number
	AssociationID: number
	SalesRepID: number
	InstitutionID: number
	ChainID: number
	MerchantDescription: string
	AlliancePartnerID: number
	ISO_ID: number
	FullMerchantID: number
	Status: string
	LegacyMID: number
	OpenDate: Date
	NoteID: number
	NoteTypeDescription: string
	NoteCreatedDateTime: Date
	NoteCreatedUsername: string
}

export class MerchantList implements IMerchantList {

	MerchantNumber: number = 0;
	SystemID: number = null;
	AssociationID: number = null;
	SalesRepID: number = null;
	InstitutionID: number = null;
	ChainID: number = null;
	MerchantDescription: string = null;
	AlliancePartnerID: number = null;
	ISO_ID: number = null;
	FullMerchantID: number = 0;
	Status: string = null;
	LegacyMID: number = null;
	OpenDate: Date = null;
	NoteID: number = null;
	NoteTypeDescription: string = null;
	NoteCreatedDateTime: Date = null;
	NoteCreatedUsername: string = null;

	constructor(src?: IMerchantList) {
		if (src) {
			this.MerchantNumber = src.MerchantNumber;
			this.SystemID = src.SystemID;
			this.AssociationID = src.AssociationID;
			this.SalesRepID = src.SalesRepID;
			this.InstitutionID = src.InstitutionID;
			this.ChainID = src.ChainID;
			this.MerchantDescription = src.MerchantDescription;
			this.AlliancePartnerID = src.AlliancePartnerID;
			this.ISO_ID = src.ISO_ID;
			this.FullMerchantID = src.FullMerchantID;
			this.Status = src.Status;
			this.LegacyMID = src.LegacyMID;
			this.OpenDate = src.OpenDate;
			this.NoteID = src.NoteID;
			this.NoteTypeDescription = src.NoteTypeDescription;
			this.NoteCreatedDateTime = src.NoteCreatedDateTime;
			this.NoteCreatedUsername = src.NoteCreatedUsername;
		}
	}

}

export interface IMerchantProfile {

	TypeOfGoods: string
	ProductType: number
	BusinesssType: number
	SICCode: number
	MCCCode: number
	AOBCode: number
	Ownership: string
	AverageTicket: number
	MaxTicket: number
	MonthlyVolume: number
	Processor: string
	SalesEntityID: number
	SalesEntityName: string
	MerchantID: string
	Amex: string
	AmexNumber: number
	PINDebit: boolean
	EBT: boolean
	EBTNumber: number
	FedTaxID: string
	NumLocations: number
	YearsInBusiness: number
	YearsOwned: number
	PriorProcessing: boolean
	PriorBankruptcy: boolean
	CardSwipePct: number
	ManualPct: number
	MOTOPct: number
	ECommPct: number
	BankName: string
	RoutingNumber: number
	AccountNumber: string
	BankPhone: string
	Status: string
	MerchantDescription: string
	OpenDate: Date
}

export class MerchantProfile implements IMerchantProfile {

	TypeOfGoods: string = null;
	ProductType: number = null;
	BusinesssType: number = null;
	SICCode: number = null;
	MCCCode: number = null;
	AOBCode: number = null;
	Ownership: string = null;
	AverageTicket: number = null;
	MaxTicket: number = null;
	MonthlyVolume: number = null;
	Processor: string = null;
	SalesEntityID: number = null;
	SalesEntityName: string = null;
	MerchantID: string = null;
	Amex: string = null;
	AmexNumber: number = null;
	PINDebit: boolean = null;
	EBT: boolean = null;
	EBTNumber: number = null;
	FedTaxID: string = null;
	NumLocations: number = null;
	YearsInBusiness: number = null;
	YearsOwned: number = null;
	PriorProcessing: boolean = null;
	PriorBankruptcy: boolean = null;
	CardSwipePct: number = null;
	ManualPct: number = null;
	MOTOPct: number = null;
	ECommPct: number = null;
	BankName: string = null;
	RoutingNumber: number = null;
	AccountNumber: string = null;
	BankPhone: string = null;
	Status: string = null;
	MerchantDescription: string = null;
	OpenDate: Date = null;

	constructor(src?: IMerchantProfile) {
		if (src) {
			this.TypeOfGoods = src.TypeOfGoods;
			this.ProductType = src.ProductType;
			this.BusinesssType = src.BusinesssType;
			this.SICCode = src.SICCode;
			this.MCCCode = src.MCCCode;
			this.AOBCode = src.AOBCode;
			this.Ownership = src.Ownership;
			this.AverageTicket = src.AverageTicket;
			this.MaxTicket = src.MaxTicket;
			this.MonthlyVolume = src.MonthlyVolume;
			this.Processor = src.Processor;
			this.SalesEntityID = src.SalesEntityID;
			this.SalesEntityName = src.SalesEntityName;
			this.MerchantID = src.MerchantID;
			this.Amex = src.Amex;
			this.AmexNumber = src.AmexNumber;
			this.PINDebit = src.PINDebit;
			this.EBT = src.EBT;
			this.EBTNumber = src.EBTNumber;
			this.FedTaxID = src.FedTaxID;
			this.NumLocations = src.NumLocations;
			this.YearsInBusiness = src.YearsInBusiness;
			this.YearsOwned = src.YearsOwned;
			this.PriorProcessing = src.PriorProcessing;
			this.PriorBankruptcy = src.PriorBankruptcy;
			this.CardSwipePct = src.CardSwipePct;
			this.ManualPct = src.ManualPct;
			this.MOTOPct = src.MOTOPct;
			this.ECommPct = src.ECommPct;
			this.BankName = src.BankName;
			this.RoutingNumber = src.RoutingNumber;
			this.AccountNumber = src.AccountNumber;
			this.BankPhone = src.BankPhone;
			this.Status = src.Status;
			this.MerchantDescription = src.MerchantDescription;
			this.OpenDate = src.OpenDate;
		}
	}

}

export interface IMerchantOwners {

	OwnerID: number;
	LastName: string;
	FirstName: string;
	MiddleName: string;
	Email: string;
	Title: string;
	DateOfBirth: Date;
	SSN: string;
	Addr1: string;
	Addr2: string;
	City: string;
	State: string;
	Country: string;
	PostCode: string;
	YearsAtAddress: number;
	Telephone: string;
	IDNumber: string;
	IDState: string;
	IDCountry: string;
}

export class MerchantOwners implements IMerchantOwners {

	OwnerID: number = 0;
	LastName: string = null;
	FirstName: string = null;
	MiddleName: string = null;
	Email: string = null;
	Title: string = null;
	DateOfBirth: Date = null;
	SSN: string = null;
	Addr1: string = null;
	Addr2: string = null;
	City: string = null;
	State: string = null;
	Country: string = null;
	PostCode: string = null;
	YearsAtAddress: number = null;
	Telephone: string = null;
	IDNumber: string = null;
	IDState: string = null;
	IDCountry: string = null;

	constructor(src?: IMerchantOwners) {
		if (src) {
			this.OwnerID = src.OwnerID;
			this.LastName = src.LastName;
			this.FirstName = src.FirstName;
			this.MiddleName = src.MiddleName;
			this.Email = src.Email;
			this.Title = src.Title;
			this.DateOfBirth = src.DateOfBirth;
			this.SSN = src.SSN;
			this.Addr1 = src.Addr1;
			this.Addr2 = src.Addr2;
			this.City = src.City;
			this.State = src.State;
			this.Country = src.Country;
			this.PostCode = src.PostCode;
			this.YearsAtAddress = src.YearsAtAddress;
			this.Telephone = src.Telephone;
			this.IDNumber = src.IDNumber;
			this.IDState = src.IDState;
			this.IDCountry = src.IDCountry;
		}
	}

}

export interface IMerchantNote {
	ApplicationCreator: string;
	CreatedById: string;
	CreatedDateTime: string;
	CreatedUser: string;
	CreatedUserName: string;
	MerchantId: number;
	Note: string;
	NoteId: string;
	NoteTypeDescription: string;
	NoteTypeId: string;
	UpdatedById: string;
	UpdatedDateTime: string;
	UpdatedUser: string;
	UpdatedUserName: string;
	isPriority: string;
	links: string;
}

export class MerchantNote implements IMerchantNote {
	ApplicationCreator: string = null;
	CreatedById: string = null;
	CreatedDateTime: string = null;
	CreatedUser: string = null;
	CreatedUserName: string = null;
	MerchantId: number = null;
	Note: string = null;
	NoteId: string = null;
	NoteTypeDescription: string = null;
	NoteTypeId: string = null;
	UpdatedById: string = null;
	UpdatedDateTime: string = null;
	UpdatedUser: string = null;
	UpdatedUserName: string = null;
	isPriority: string = null;
	links: string = null;
	constructor(src?: IMerchantNote) {
		if (src) {
			this.ApplicationCreator = src.ApplicationCreator;
			this.CreatedById = src.CreatedById;
			this.CreatedDateTime = src.CreatedDateTime;
			this.CreatedUser = src.CreatedUser;
			this.CreatedUserName = src.CreatedUserName;
			this.MerchantId = src.MerchantId;
			this.Note = src.Note;
			this.NoteId = src.NoteId;
			this.NoteTypeDescription = src.NoteTypeDescription;
			this.NoteTypeId = src.NoteTypeId;
			this.UpdatedById = src.UpdatedById;
			this.UpdatedDateTime = src.UpdatedDateTime;
			this.UpdatedUser = src.UpdatedUser;
			this.UpdatedUserName = src.UpdatedUserName;
			this.isPriority = src.isPriority;
			this.links = src.links;
		}
	}
}

export interface IMerchantNotePaging {

	Notes: MerchantNote[];
	TotalRows: number;
}

export class MerchantNotePaging implements IMerchantNotePaging {

	Notes: MerchantNote[] = [];
	TotalRows: number = 0;

	constructor(src?: IMerchantNotePaging) {
		if (src) {
			this.Notes = src.Notes;
			this.TotalRows = src.TotalRows;
		}
	}

}


export interface IMerchantContact {

	Contact: string;
	Address: string;
	City: string;
	State: string;
	Zip: string;
	Telephone: string;
	Fax: string;
	Email: string;
}

export class MerchantContact implements IMerchantContact {
	UpdatedDateTime
	Contact: string = null;
	Address: string = null;
	City: string = null;
	State: string = null;
	Zip: string = null;
	Telephone: string = null;
	Fax: string = null;
	Email: string = null;

	constructor(src?: IMerchantContact) {
		if (src) {
			this.Contact = src.Contact;
			this.Address = src.Address;
			this.City = src.City;
			this.State = src.State;
			this.Zip = src.Zip;
			this.Telephone = src.Telephone;
			this.Fax = src.Fax;
			this.Email = src.Email;
		}
	}
}


export interface IMerchantCompensation {

	CompPlanInstanceID: string;
	RelationshipTypeID: string;
	RelationshipTypeName: string;
	Program: string;
	RecipientID: string;
	RecipientName: string;
	TieringType: string;
	StartDate: string;
	EndDate: string;
	PriceListID: string;
	PriceListName: string;
}

export class MerchantCompensation implements IMerchantCompensation {

	CompPlanInstanceID: string = null;
	RelationshipTypeID: string = null;
	RelationshipTypeName: string = null;
	Program: string = null;
	RecipientID: string = null;
	RecipientName: string = null;
	TieringType: string = null;
	StartDate: string = null;
	EndDate: string = null;
	PriceListID: string = null;
	PriceListName: string = null;

	constructor(src?: IMerchantCompensation) {
		if (src) {
			this.CompPlanInstanceID = src.CompPlanInstanceID;
			this.RelationshipTypeID = src.RelationshipTypeID;
			this.RelationshipTypeName = src.RelationshipTypeName;
			this.Program = src.Program;
			this.RecipientID = src.RecipientID;
			this.RecipientName = src.RecipientName;
			this.TieringType = src.TieringType;
			this.StartDate = src.StartDate;
			this.EndDate = src.EndDate;
			this.PriceListID = src.PriceListID;
			this.PriceListName = src.PriceListName;
		}
	}

}

export interface IMerchantCompensationData {

	MerchantComp: MerchantCompensation[]
	CompPlanInstanceID: number
	ContractID: number
	ContractName: string
}

export class MerchantCompensationData implements IMerchantCompensationData {

	MerchantComp: MerchantCompensation[] = [];
	CompPlanInstanceID: number = 0;
	ContractID: number = 0;
	ContractName: string = null;

	constructor(src?: IMerchantCompensationData) {
		if (src) {
			this.MerchantComp = src.MerchantComp;
			this.CompPlanInstanceID = src.CompPlanInstanceID;
			this.ContractID = src.ContractID;
			this.ContractName = src.ContractName;
		}
	}

}

export interface IMerchantsCount {

	ActiveMerchantCount: number
	OpenMerchantCount: number
	AttritionPercentage: number
	PCICompliance: number
}

export class MerchantsCount implements IMerchantsCount {

	ActiveMerchantCount: number = 0;
	OpenMerchantCount: number = 0;
	AttritionPercentage: number = 0;
	PCICompliance: number = 0;

	constructor(src?: IMerchantsCount) {
		if (src) {
			this.ActiveMerchantCount = src.ActiveMerchantCount;
			this.OpenMerchantCount = src.OpenMerchantCount;
			this.AttritionPercentage = src.AttritionPercentage;
			this.PCICompliance = src.PCICompliance;
		}
	}

}

export interface IAverageTicketVolume {

	Scale: string
	Interval: number
	StartDate: Date
	EndDate: Date
	AvgTicket: number
	Volume: number
}

export class AverageTicketVolume implements IAverageTicketVolume {

	Scale: string = null;
	Interval: number = 0;
	StartDate: Date = new Date(0);
	EndDate: Date = new Date(0);
	AvgTicket: number = 0;
	Volume: number = 0;

	constructor(src?: IAverageTicketVolume) {
		if (src) {
			this.Scale = src.Scale;
			this.Interval = src.Interval;
			this.StartDate = src.StartDate;
			this.EndDate = src.EndDate;
			this.AvgTicket = src.AvgTicket;
			this.Volume = src.Volume;
		}
	}

}

export interface IBoardedMerchantCounts {

	Total: number
	OpenProcessing: number
	OpenNotProcessing: number
	Closed: number
}

export class BoardedMerchantCounts implements IBoardedMerchantCounts {

	Total: number = 0;
	OpenProcessing: number = 0;
	OpenNotProcessing: number = 0;
	Closed: number = 0;

	constructor(src?: IBoardedMerchantCounts) {
		if (src) {
			this.Total = src.Total;
			this.OpenProcessing = src.OpenProcessing;
			this.OpenNotProcessing = src.OpenNotProcessing;
			this.Closed = src.Closed;
		}
	}

}

export interface IPortfolioGrowth {

	Scale: string
	Interval: number
	StartDate: Date
	EndDate: Date
	OpenMerchants: number
}

export class PortfolioGrowth implements IPortfolioGrowth {

	Scale: string = null;
	Interval: number = 0;
	StartDate: Date = new Date(0);
	EndDate: Date = new Date(0);
	OpenMerchants: number = 0;

	constructor(src?: IPortfolioGrowth) {
		if (src) {
			this.Scale = src.Scale;
			this.Interval = src.Interval;
			this.StartDate = src.StartDate;
			this.EndDate = src.EndDate;
			this.OpenMerchants = src.OpenMerchants;
		}
	}

}

export interface IMerchantDashboardData {

	AvgTicketVolume: AverageTicketVolume[]
	BoardedMerchCounts: BoardedMerchantCounts[]
	PortGrowth: PortfolioGrowth[]
	ClosedMerchCount: ClosedMerchantCount[]
	ResidTrends: ResidualTrends[]
}

export class MerchantDashboardData implements IMerchantDashboardData {

	AvgTicketVolume: AverageTicketVolume[] = [];
	BoardedMerchCounts: BoardedMerchantCounts[] = [];
	PortGrowth: PortfolioGrowth[] = [];
	ClosedMerchCount: ClosedMerchantCount[] = [];
	ResidTrends: ResidualTrends[] = [];

	constructor(src?: IMerchantDashboardData) {
		if (src) {
			this.AvgTicketVolume = src.AvgTicketVolume;
			this.BoardedMerchCounts = src.BoardedMerchCounts;
			this.PortGrowth = src.PortGrowth;
			this.ClosedMerchCount = src.ClosedMerchCount;
			this.ResidTrends = src.ResidTrends;
		}
	}

}

export interface IClosedMerchantCount {

	DateRangeDescription: string
	MerchantClosedCount: number
}

export class ClosedMerchantCount implements IClosedMerchantCount {

	DateRangeDescription: string = null;
	MerchantClosedCount: number = 0;

	constructor(src?: IClosedMerchantCount) {
		if (src) {
			this.DateRangeDescription = src.DateRangeDescription;
			this.MerchantClosedCount = src.MerchantClosedCount;
		}
	}

}

export interface IResidualTrends {

	Period: string
	Volume: number
	Payout: number
}

export class ResidualTrends implements IResidualTrends {

	Period: string = null;
	Volume: number = 0;
	Payout: number = 0;

	constructor(src?: IResidualTrends) {
		if (src) {
			this.Period = src.Period;
			this.Volume = src.Volume;
			this.Payout = src.Payout;
		}
	}

}

export interface ICompPlanInstanceInq {

	SalesEntityID: number
	SalesEntityRecipientID: number
	RelationshipTypeID: number
	ContractInstanceID: number
	ReferenceID: number
	MerchantNumber: number
	PayFromContractInstanceID: number
	StartPage: number
	MaxRows: number
}

export class CompPlanInstanceInq implements ICompPlanInstanceInq {

	SalesEntityID: number = null;
	SalesEntityRecipientID: number = null;
	RelationshipTypeID: number = null;
	ContractInstanceID: number = null;
	ReferenceID: number = null;
	MerchantNumber: number = null;
	PayFromContractInstanceID: number = null;
	StartPage: number = null;
	MaxRows: number = null;

	constructor(src?: ICompPlanInstanceInq) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.SalesEntityRecipientID = src.SalesEntityRecipientID;
			this.RelationshipTypeID = src.RelationshipTypeID;
			this.ContractInstanceID = src.ContractInstanceID;
			this.ReferenceID = src.ReferenceID;
			this.MerchantNumber = src.MerchantNumber;
			this.PayFromContractInstanceID = src.PayFromContractInstanceID;
			this.StartPage = src.StartPage;
			this.MaxRows = src.MaxRows;
		}
	}

}

export interface ICompPlanInstance {

	CompPlanInstanceID: number
	SalesEntityRecipientID: number
	RelationshipTypeID: number
	ContractInstanceID: number
	ReferenceID: number
	MerchantNumber: number
	ContractPercentage: number
	IsNet: boolean
	EffectivePercentage: number
	TieringType: number
	PayFromContractInstanceID: number
	CreatedDateTime: Date
}

export class CompPlanInstance implements ICompPlanInstance {

	CompPlanInstanceID: number = null;
	SalesEntityRecipientID: number = null;
	RelationshipTypeID: number = null;
	ContractInstanceID: number = null;
	ReferenceID: number = null;
	MerchantNumber: number = null;
	ContractPercentage: number = null;
	IsNet: boolean = null;
	EffectivePercentage: number = null;
	TieringType: number = null;
	PayFromContractInstanceID: number = null;
	CreatedDateTime: Date = null;

	constructor(src?: ICompPlanInstance) {
		if (src) {
			this.CompPlanInstanceID = src.CompPlanInstanceID;
			this.SalesEntityRecipientID = src.SalesEntityRecipientID;
			this.RelationshipTypeID = src.RelationshipTypeID;
			this.ContractInstanceID = src.ContractInstanceID;
			this.ReferenceID = src.ReferenceID;
			this.MerchantNumber = src.MerchantNumber;
			this.ContractPercentage = src.ContractPercentage;
			this.IsNet = src.IsNet;
			this.EffectivePercentage = src.EffectivePercentage;
			this.TieringType = src.TieringType;
			this.PayFromContractInstanceID = src.PayFromContractInstanceID;
			this.CreatedDateTime = src.CreatedDateTime;
		}
	}

}

export interface IContract {

	ContractID: number
	ParentContractID: number
	SalesEntityID: number
	Name: string
	IsDefault: boolean
	CreatedDateTime: Date
	AutoBoard: boolean
	WriteAll: boolean
	CRMInstanceID: number
	CRMUserID: string
}

export class Contract implements IContract {

	ContractID: number = null;
	ParentContractID: number = null;
	SalesEntityID: number = null;
	Name: string = null;
	IsDefault: boolean = null;
	CreatedDateTime: Date = null;
	AutoBoard: boolean = null;
	WriteAll: boolean = null;
	CRMInstanceID: number = null;
	CRMUserID: string = null;

	constructor(src?: IContract) {
		if (src) {
			this.ContractID = src.ContractID;
			this.ParentContractID = src.ParentContractID;
			this.SalesEntityID = src.SalesEntityID;
			this.Name = src.Name;
			this.IsDefault = src.IsDefault;
			this.CreatedDateTime = src.CreatedDateTime;
			this.AutoBoard = src.AutoBoard;
			this.WriteAll = src.WriteAll;
			this.CRMInstanceID = src.CRMInstanceID;
			this.CRMUserID = src.CRMUserID;
		}
	}

}

export interface IContractResult {

	Result: Contract[]
	TotalRows: number
}

export class ContractResult implements IContractResult {

	Result: Contract[] = [];
	TotalRows: number = 0;

	constructor(src?: IContractResult) {
		if (src) {
			this.Result = src.Result;
			this.TotalRows = src.TotalRows;
		}
	}

}

export interface IApplicationsCntInq {

	ISOID: number
	IncludeSubAgents: boolean
	Permissions: number[]
}

export class ApplicationsCntInq implements IApplicationsCntInq {

	ISOID: number = 0;
	IncludeSubAgents: boolean = false;
	Permissions: number[] = [];

	constructor(src?: IApplicationsCntInq) {
		if (src) {
			this.ISOID = src.ISOID;
			this.IncludeSubAgents = src.IncludeSubAgents;
			this.Permissions = src.Permissions;
		}
	}

}

export interface IApplicationCounts {

	CompleteMTD: number
	StartDateMTD: Date
	EndDateMTD: Date
	CompleteYTD: number
	StartDateYTD: Date
	EndDateYTD: Date
}

export class ApplicationCounts implements IApplicationCounts {

	CompleteMTD: number = 0;
	StartDateMTD: Date = new Date(0);
	EndDateMTD: Date = new Date(0);
	CompleteYTD: number = 0;
	StartDateYTD: Date = new Date(0);
	EndDateYTD: Date = new Date(0);

	constructor(src?: IApplicationCounts) {
		if (src) {
			this.CompleteMTD = src.CompleteMTD;
			this.StartDateMTD = src.StartDateMTD;
			this.EndDateMTD = src.EndDateMTD;
			this.CompleteYTD = src.CompleteYTD;
			this.StartDateYTD = src.StartDateYTD;
			this.EndDateYTD = src.EndDateYTD;
		}
	}

}

export interface IKPIData {

	CommissionsDate: Date
	TotalSalesVolume: number
	TotalPayout: number
	Margin: number
}

export class KPIData implements IKPIData {

	CommissionsDate: Date = null;
	TotalSalesVolume: number = null;
	TotalPayout: number = null;
	Margin: number = null;

	constructor(src?: IKPIData) {
		if (src) {
			this.CommissionsDate = src.CommissionsDate;
			this.TotalSalesVolume = src.TotalSalesVolume;
			this.TotalPayout = src.TotalPayout;
			this.Margin = src.Margin;
		}
	}

}

export interface IResidualsDetailByCategoryInq {

	CategoryID: number
	SalesEntityID: number
	CommissionsDate: Date
	MerchantID: number
	Export: boolean
}

export class ResidualsDetailByCategoryInq implements IResidualsDetailByCategoryInq {

	CategoryID: number = 0;
	SalesEntityID: number = null;
	CommissionsDate: Date = null;
	MerchantID: number = null;
	Export: boolean = null;

	constructor(src?: IResidualsDetailByCategoryInq) {
		if (src) {
			this.CategoryID = src.CategoryID;
			this.SalesEntityID = src.SalesEntityID;
			this.CommissionsDate = src.CommissionsDate;
			this.MerchantID = src.MerchantID;
			this.Export = src.Export;
		}
	}

}

export interface IResidualsGetByMetricInq {

	MetricID: number
	CategoryID: number
	SalesEntityID: number
	CommissionsDate: Date
	MerchantID: number
}

export class ResidualsGetByMetricInq implements IResidualsGetByMetricInq {

	MetricID: number = 0;
	CategoryID: number = 0;
	SalesEntityID: number = null;
	CommissionsDate: Date = null;
	MerchantID: number = null;

	constructor(src?: IResidualsGetByMetricInq) {
		if (src) {
			this.MetricID = src.MetricID;
			this.CategoryID = src.CategoryID;
			this.SalesEntityID = src.SalesEntityID;
			this.CommissionsDate = src.CommissionsDate;
			this.MerchantID = src.MerchantID;
		}
	}

}

export interface IResidualsDetailByCategory {

	Detail: boolean
	CategoryName: string
	SubCategoryTitle: string
	ShowSalesAmount: boolean
	ShowTranCount: boolean
	ShowIncome: boolean
	ShowExpenses: boolean
	ShowNetIncome: boolean
	ShowPayout: boolean
	ResidualsByCategoryDetail: ResidualsDetailByCategoryDetail[]
}

export class ResidualsDetailByCategory implements IResidualsDetailByCategory {

	Detail: boolean = null;
	CategoryName: string = null;
	SubCategoryTitle: string = null;
	ShowSalesAmount: boolean = null;
	ShowTranCount: boolean = null;
	ShowIncome: boolean = null;
	ShowExpenses: boolean = null;
	ShowNetIncome: boolean = null;
	ShowPayout: boolean = null;
	ResidualsByCategoryDetail: ResidualsDetailByCategoryDetail[] = [];

	constructor(src?: IResidualsDetailByCategory) {
		if (src) {
			this.Detail = src.Detail;
			this.CategoryName = src.CategoryName;
			this.SubCategoryTitle = src.SubCategoryTitle;
			this.ShowSalesAmount = src.ShowSalesAmount;
			this.ShowTranCount = src.ShowTranCount;
			this.ShowIncome = src.ShowIncome;
			this.ShowExpenses = src.ShowExpenses;
			this.ShowNetIncome = src.ShowNetIncome;
			this.ShowPayout = src.ShowPayout;
			this.ResidualsByCategoryDetail = src.ResidualsByCategoryDetail;
		}
	}

}

export interface IResidualsDetailByCategoryDetail {

	CategoryID: number
	CategoryName: string
	SalesAmount: number
	TranCount: number
	Income: number
	Expenses: number
	NetIncome: number
	Payout: number
	HasMerchantDetail: boolean
}

export class ResidualsDetailByCategoryDetail implements IResidualsDetailByCategoryDetail {

	CategoryID: number = 0;
	CategoryName: string = null;
	SalesAmount: number = 0;
	TranCount: number = 0;
	Income: number = 0;
	Expenses: number = 0;
	NetIncome: number = 0;
	Payout: number = 0;
	HasMerchantDetail: boolean = false;

	constructor(src?: IResidualsDetailByCategoryDetail) {
		if (src) {
			this.CategoryID = src.CategoryID;
			this.CategoryName = src.CategoryName;
			this.SalesAmount = src.SalesAmount;
			this.TranCount = src.TranCount;
			this.Income = src.Income;
			this.Expenses = src.Expenses;
			this.NetIncome = src.NetIncome;
			this.Payout = src.Payout;
			this.HasMerchantDetail = src.HasMerchantDetail;
		}
	}

}

export interface IResidualsDetailByMetric {

	MetricName: string
	ShowSalesAmount: boolean
	ShowTranCount: boolean
	ShowIncome: boolean
	ShowExpenses: boolean
	ShowNetIncome: boolean
	ShowPayout: boolean
	ResidualsByMetricDetail: ResidualsDetailByMetricDetail[]
}

export class ResidualsDetailByMetric implements IResidualsDetailByMetric {

	MetricName: string = null;
	ShowSalesAmount: boolean = null;
	ShowTranCount: boolean = null;
	ShowIncome: boolean = null;
	ShowExpenses: boolean = null;
	ShowNetIncome: boolean = null;
	ShowPayout: boolean = null;
	ResidualsByMetricDetail: ResidualsDetailByMetricDetail[] = [];

	constructor(src?: IResidualsDetailByMetric) {
		if (src) {
			this.MetricName = src.MetricName;
			this.ShowSalesAmount = src.ShowSalesAmount;
			this.ShowTranCount = src.ShowTranCount;
			this.ShowIncome = src.ShowIncome;
			this.ShowExpenses = src.ShowExpenses;
			this.ShowNetIncome = src.ShowNetIncome;
			this.ShowPayout = src.ShowPayout;
			this.ResidualsByMetricDetail = src.ResidualsByMetricDetail;
		}
	}

}

export interface IResidualsDetailByMetricDetail {

	MetricID: number
	MerchantID: number
	MerchantDBA: string
	SalesAmount: number
	TranCount: number
	Income: number
	Expenses: number
	NetIncome: number
	Payout: number
	SalesEntityID: number
	SalesEntityName: string
	ISONumber: string
}

export class ResidualsDetailByMetricDetail implements IResidualsDetailByMetricDetail {

	MetricID: number = 0;
	MerchantID: number = 0;
	MerchantDBA: string = null;
	SalesAmount: number = 0;
	TranCount: number = 0;
	Income: number = 0;
	Expenses: number = 0;
	NetIncome: number = 0;
	Payout: number = 0;
	SalesEntityID: number = null;
	SalesEntityName: string = null;
	ISONumber: string = null;

	constructor(src?: IResidualsDetailByMetricDetail) {
		if (src) {
			this.MetricID = src.MetricID;
			this.MerchantID = src.MerchantID;
			this.MerchantDBA = src.MerchantDBA;
			this.SalesAmount = src.SalesAmount;
			this.TranCount = src.TranCount;
			this.Income = src.Income;
			this.Expenses = src.Expenses;
			this.NetIncome = src.NetIncome;
			this.Payout = src.Payout;
			this.SalesEntityID = src.SalesEntityID;
			this.SalesEntityName = src.SalesEntityName;
			this.ISONumber = src.ISONumber;
		}
	}

}

export interface IResidualsSummaryCategories {

	CategoryID: number
	CategoryName: string
	SubCategoryTitle: string
	ShowSalesAmount: boolean
	ShowTranCount: boolean
	ShowIncome: boolean
	ShowExpenses: boolean
	ShowNetIncome: boolean
	ShowPayout: boolean
}

export class ResidualsSummaryCategories implements IResidualsSummaryCategories {

	CategoryID: number = 0;
	CategoryName: string = null;
	SubCategoryTitle: string = null;
	ShowSalesAmount: boolean = false;
	ShowTranCount: boolean = false;
	ShowIncome: boolean = false;
	ShowExpenses: boolean = false;
	ShowNetIncome: boolean = false;
	ShowPayout: boolean = false;

	constructor(src?: IResidualsSummaryCategories) {
		if (src) {
			this.CategoryID = src.CategoryID;
			this.CategoryName = src.CategoryName;
			this.SubCategoryTitle = src.SubCategoryTitle;
			this.ShowSalesAmount = src.ShowSalesAmount;
			this.ShowTranCount = src.ShowTranCount;
			this.ShowIncome = src.ShowIncome;
			this.ShowExpenses = src.ShowExpenses;
			this.ShowNetIncome = src.ShowNetIncome;
			this.ShowPayout = src.ShowPayout;
		}
	}

}

export interface IResidualsSummary {

	TotalVolume: number
	Payout: number
	Margin: number
	ResidualAdjustmentsSummary: ResidualAdjustmentsSummary
	BackendProcessingSummary: BackendProcessingSummary
	FrontEndTransactionFeeSummary: FrontEndTransactionFeeSummary
	MiscellaneousTransactionFeeSummary: MiscellaneousTransactionFeeSummary
	AchNetRejectActivitySummary: AchNetRejectActivitySummary
	ResidualPayoutBinReserveAdjustmentsSummary: ResidualPayoutBinReserveAdjustmentsSummary
}

export class ResidualsSummary implements IResidualsSummary {

	TotalVolume: number = 0;
	Payout: number = 0;
	Margin: number = 0;
	ResidualAdjustmentsSummary: ResidualAdjustmentsSummary = null;
	BackendProcessingSummary: BackendProcessingSummary = null;
	FrontEndTransactionFeeSummary: FrontEndTransactionFeeSummary = null;
	MiscellaneousTransactionFeeSummary: MiscellaneousTransactionFeeSummary = null;
	AchNetRejectActivitySummary: AchNetRejectActivitySummary = null;
	ResidualPayoutBinReserveAdjustmentsSummary: ResidualPayoutBinReserveAdjustmentsSummary = null;

	constructor(src?: IResidualsSummary) {
		if (src) {
			this.TotalVolume = src.TotalVolume;
			this.Payout = src.Payout;
			this.Margin = src.Margin;
			this.ResidualAdjustmentsSummary = src.ResidualAdjustmentsSummary;
			this.BackendProcessingSummary = src.BackendProcessingSummary;
			this.FrontEndTransactionFeeSummary = src.FrontEndTransactionFeeSummary;
			this.MiscellaneousTransactionFeeSummary = src.MiscellaneousTransactionFeeSummary;
			this.AchNetRejectActivitySummary = src.AchNetRejectActivitySummary;
			this.ResidualPayoutBinReserveAdjustmentsSummary = src.ResidualPayoutBinReserveAdjustmentsSummary;
		}
	}

}

export interface IResidualAdjustmentsSummary {

	Items: ResidualAdjustmentsItem[]
}

export class ResidualAdjustmentsSummary implements IResidualAdjustmentsSummary {

	Items: ResidualAdjustmentsItem[] = [];

	constructor(src?: IResidualAdjustmentsSummary) {
		if (src) {
			this.Items = src.Items;
		}
	}

}

export interface IResidualAdjustmentsItem {

	Description: string
	Payout: number
}

export class ResidualAdjustmentsItem implements IResidualAdjustmentsItem {

	Description: string = null;
	Payout: number = 0;

	constructor(src?: IResidualAdjustmentsItem) {
		if (src) {
			this.Description = src.Description;
			this.Payout = src.Payout;
		}
	}

}

export interface IBackendProcessingSummary {

	Items: BackendProcessingItem[]
}

export class BackendProcessingSummary implements IBackendProcessingSummary {

	Items: BackendProcessingItem[] = [];

	constructor(src?: IBackendProcessingSummary) {
		if (src) {
			this.Items = src.Items;
		}
	}

}

export interface IBackendProcessingItem {

	CardType: string
	SalesAmount: number
	TransactionCount: number
	Income: number
	Expenses: number
	NetIncome: number
	Payout: number
}

export class BackendProcessingItem implements IBackendProcessingItem {

	CardType: string = null;
	SalesAmount: number = 0;
	TransactionCount: number = 0;
	Income: number = 0;
	Expenses: number = 0;
	NetIncome: number = 0;
	Payout: number = 0;

	constructor(src?: IBackendProcessingItem) {
		if (src) {
			this.CardType = src.CardType;
			this.SalesAmount = src.SalesAmount;
			this.TransactionCount = src.TransactionCount;
			this.Income = src.Income;
			this.Expenses = src.Expenses;
			this.NetIncome = src.NetIncome;
			this.Payout = src.Payout;
		}
	}

}

export interface IFrontEndTransactionFeeSummary {

	Items: FrontEndTransactionFeeItem[]
}

export class FrontEndTransactionFeeSummary implements IFrontEndTransactionFeeSummary {

	Items: FrontEndTransactionFeeItem[] = [];

	constructor(src?: IFrontEndTransactionFeeSummary) {
		if (src) {
			this.Items = src.Items;
		}
	}

}

export interface IFrontEndTransactionFeeItem {

	PlatformType: string
	TransactionCount: number
	Income: number
	Expenses: number
	NetIncome: number
	Payout: number
}

export class FrontEndTransactionFeeItem implements IFrontEndTransactionFeeItem {

	PlatformType: string = null;
	TransactionCount: number = 0;
	Income: number = 0;
	Expenses: number = 0;
	NetIncome: number = 0;
	Payout: number = 0;

	constructor(src?: IFrontEndTransactionFeeItem) {
		if (src) {
			this.PlatformType = src.PlatformType;
			this.TransactionCount = src.TransactionCount;
			this.Income = src.Income;
			this.Expenses = src.Expenses;
			this.NetIncome = src.NetIncome;
			this.Payout = src.Payout;
		}
	}

}

export interface IMiscellaneousTransactionFeeSummary {

	Items: MiscellaneousTransactionFeeItem[]
}

export class MiscellaneousTransactionFeeSummary implements IMiscellaneousTransactionFeeSummary {

	Items: MiscellaneousTransactionFeeItem[] = [];

	constructor(src?: IMiscellaneousTransactionFeeSummary) {
		if (src) {
			this.Items = src.Items;
		}
	}

}

export interface IMiscellaneousTransactionFeeItem {

	FeeType: string
	TransactionCount: number
	Income: number
	Expenses: number
	NetIncome: number
	Payout: number
}

export class MiscellaneousTransactionFeeItem implements IMiscellaneousTransactionFeeItem {

	FeeType: string = null;
	TransactionCount: number = 0;
	Income: number = 0;
	Expenses: number = 0;
	NetIncome: number = 0;
	Payout: number = 0;

	constructor(src?: IMiscellaneousTransactionFeeItem) {
		if (src) {
			this.FeeType = src.FeeType;
			this.TransactionCount = src.TransactionCount;
			this.Income = src.Income;
			this.Expenses = src.Expenses;
			this.NetIncome = src.NetIncome;
			this.Payout = src.Payout;
		}
	}

}

export interface IAchNetRejectActivitySummary {

	Items: AchNetRejectActivityItem[]
}

export class AchNetRejectActivitySummary implements IAchNetRejectActivitySummary {

	Items: AchNetRejectActivityItem[] = [];

	constructor(src?: IAchNetRejectActivitySummary) {
		if (src) {
			this.Items = src.Items;
		}
	}

}

export interface IAchNetRejectActivityItem {

	CardType: string
	TransactionCount: number
	Income: number
	Expenses: number
	NetIncome: number
	Payout: number
}

export class AchNetRejectActivityItem implements IAchNetRejectActivityItem {

	CardType: string = null;
	TransactionCount: number = 0;
	Income: number = 0;
	Expenses: number = 0;
	NetIncome: number = 0;
	Payout: number = 0;

	constructor(src?: IAchNetRejectActivityItem) {
		if (src) {
			this.CardType = src.CardType;
			this.TransactionCount = src.TransactionCount;
			this.Income = src.Income;
			this.Expenses = src.Expenses;
			this.NetIncome = src.NetIncome;
			this.Payout = src.Payout;
		}
	}

}

export interface IResidualPayoutBinReserveAdjustmentsSummary {

	Items: ResidualPayoutBinReserveAdjustmentItem[]
	PayoutPriorToAdjustment: number
	PayoutIncludingAdjustment: number
}

export class ResidualPayoutBinReserveAdjustmentsSummary implements IResidualPayoutBinReserveAdjustmentsSummary {

	Items: ResidualPayoutBinReserveAdjustmentItem[] = [];
	PayoutPriorToAdjustment: number = 0;
	PayoutIncludingAdjustment: number = 0;

	constructor(src?: IResidualPayoutBinReserveAdjustmentsSummary) {
		if (src) {
			this.Items = src.Items;
			this.PayoutPriorToAdjustment = src.PayoutPriorToAdjustment;
			this.PayoutIncludingAdjustment = src.PayoutIncludingAdjustment;
		}
	}

}

export interface IResidualPayoutBinReserveAdjustmentItem {

	BinSponsorship: string
	Amount: number
}

export class ResidualPayoutBinReserveAdjustmentItem implements IResidualPayoutBinReserveAdjustmentItem {

	BinSponsorship: string = null;
	Amount: number = 0;

	constructor(src?: IResidualPayoutBinReserveAdjustmentItem) {
		if (src) {
			this.BinSponsorship = src.BinSponsorship;
			this.Amount = src.Amount;
		}
	}

}

export interface IResidualsACHDetailByCategory {

	CommissionsDate: Date
	Detail: string
	CategoryName: string
	ShowPRIN: boolean
	ShowAssc: boolean
	ShowDescription: boolean
	ShowAPPct: boolean
	ShowPayout: boolean
	ACHDetail: ResidualsACHDetail[]
}

export class ResidualsACHDetailByCategory implements IResidualsACHDetailByCategory {

	CommissionsDate: Date = new Date(0);
	Detail: string = null;
	CategoryName: string = null;
	ShowPRIN: boolean = false;
	ShowAssc: boolean = false;
	ShowDescription: boolean = false;
	ShowAPPct: boolean = false;
	ShowPayout: boolean = false;
	ACHDetail: ResidualsACHDetail[] = [];

	constructor(src?: IResidualsACHDetailByCategory) {
		if (src) {
			this.CommissionsDate = src.CommissionsDate;
			this.Detail = src.Detail;
			this.CategoryName = src.CategoryName;
			this.ShowPRIN = src.ShowPRIN;
			this.ShowAssc = src.ShowAssc;
			this.ShowDescription = src.ShowDescription;
			this.ShowAPPct = src.ShowAPPct;
			this.ShowPayout = src.ShowPayout;
			this.ACHDetail = src.ACHDetail;
		}
	}

}

export interface IResidualsACHDetail {

	MerchantID: number
	DBA: string
	PRIN: number
	Assc: number
	Date: Date
	ACHDescription: string
	ACHReason: string
	APPct: number
	TotalAmt: number
	APAmount: number
}

export class ResidualsACHDetail implements IResidualsACHDetail {

	MerchantID: number = 0;
	DBA: string = null;
	PRIN: number = 0;
	Assc: number = 0;
	Date: Date = new Date(0);
	ACHDescription: string = null;
	ACHReason: string = null;
	APPct: number = 0;
	TotalAmt: number = 0;
	APAmount: number = 0;

	constructor(src?: IResidualsACHDetail) {
		if (src) {
			this.MerchantID = src.MerchantID;
			this.DBA = src.DBA;
			this.PRIN = src.PRIN;
			this.Assc = src.Assc;
			this.Date = src.Date;
			this.ACHDescription = src.ACHDescription;
			this.ACHReason = src.ACHReason;
			this.APPct = src.APPct;
			this.TotalAmt = src.TotalAmt;
			this.APAmount = src.APAmount;
		}
	}

}

export interface IExportResult {

	CommissionsDate: Date
	EntityDescription: string
	TotalMerchantCount: number
	NewMerchantCount: number
	ClosedMerchantCount: number
	PayoutPriorToBIN: number
	PayoutIncludingBIN: number
	Headers: ResidualsDetailByCategoryDetail[]
	c1: ResidualsDetailByCategory
	c2: ResidualsDetailByCategory
	c3: ResidualsDetailByCategory
	c4: ResidualsDetailByCategory
	c36: ResidualsDetailByCategory
	c37: ResidualsDetailByCategory
}

export class ExportResult implements IExportResult {

	CommissionsDate: Date = new Date(0);
	EntityDescription: string = null;
	TotalMerchantCount: number = 0;
	NewMerchantCount: number = 0;
	ClosedMerchantCount: number = 0;
	PayoutPriorToBIN: number = 0;
	PayoutIncludingBIN: number = 0;
	Headers: ResidualsDetailByCategoryDetail[] = [];
	c1: ResidualsDetailByCategory = null;
	c2: ResidualsDetailByCategory = null;
	c3: ResidualsDetailByCategory = null;
	c4: ResidualsDetailByCategory = null;
	c36: ResidualsDetailByCategory = null;
	c37: ResidualsDetailByCategory = null;

	constructor(src?: IExportResult) {
		if (src) {
			this.CommissionsDate = src.CommissionsDate;
			this.EntityDescription = src.EntityDescription;
			this.TotalMerchantCount = src.TotalMerchantCount;
			this.NewMerchantCount = src.NewMerchantCount;
			this.ClosedMerchantCount = src.ClosedMerchantCount;
			this.PayoutPriorToBIN = src.PayoutPriorToBIN;
			this.PayoutIncludingBIN = src.PayoutIncludingBIN;
			this.Headers = src.Headers;
			this.c1 = src.c1;
			this.c2 = src.c2;
			this.c3 = src.c3;
			this.c4 = src.c4;
			this.c36 = src.c36;
			this.c37 = src.c37;
		}
	}

}

export interface IEntityType {

	EntityTypeID: number
	EntityTypeDescription: string
}

export class EntityType implements IEntityType {

	EntityTypeID: number = 0;
	EntityTypeDescription: string = null;

	constructor(src?: IEntityType) {
		if (src) {
			this.EntityTypeID = src.EntityTypeID;
			this.EntityTypeDescription = src.EntityTypeDescription;
		}
	}

}

export interface IChannel {

	ChannelID: number
	ChannelDescription: string
}

export class Channel implements IChannel {

	ChannelID: number = 0;
	ChannelDescription: string = null;

	constructor(src?: IChannel) {
		if (src) {
			this.ChannelID = src.ChannelID;
			this.ChannelDescription = src.ChannelDescription;
		}
	}

}

export interface IAlliancePartnerESP {

	AlliancePartnerID: number
	AlliancePartnerDescription: string
}

export class AlliancePartnerESP implements IAlliancePartnerESP {

	AlliancePartnerID: number = 0;
	AlliancePartnerDescription: string = null;

	constructor(src?: IAlliancePartnerESP) {
		if (src) {
			this.AlliancePartnerID = src.AlliancePartnerID;
			this.AlliancePartnerDescription = src.AlliancePartnerDescription;
		}
	}

}

export interface IPendChangesAgg {

	TotalRows: number
	TotalChanges: number
	OldestChange: Date
	NewestChange: Date
	PendingChangeList: PendChangesAggListESP[]
}

export class PendChangesAgg implements IPendChangesAgg {

	TotalRows: number = 0;
	TotalChanges: number = 0;
	OldestChange: Date = new Date(0);
	NewestChange: Date = new Date(0);
	PendingChangeList: PendChangesAggListESP[] = [];

	constructor(src?: IPendChangesAgg) {
		if (src) {
			this.TotalRows = src.TotalRows;
			this.TotalChanges = src.TotalChanges;
			this.OldestChange = src.OldestChange;
			this.NewestChange = src.NewestChange;
			this.PendingChangeList = src.PendingChangeList;
		}
	}

}

export interface IPendChangesAggListESP {

	SalesEntityID: number
	Name: string
	FromDTM: Date
	ToDTM: Date
	ChangeCount: number
	Breadcrumbs: string
}

export class PendChangesAggListESP implements IPendChangesAggListESP {

	SalesEntityID: number = 0;
	Name: string = null;
	FromDTM: Date = new Date(0);
	ToDTM: Date = new Date(0);
	ChangeCount: number = 0;
	Breadcrumbs: string = null;

	constructor(src?: IPendChangesAggListESP) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.Name = src.Name;
			this.FromDTM = src.FromDTM;
			this.ToDTM = src.ToDTM;
			this.ChangeCount = src.ChangeCount;
			this.Breadcrumbs = src.Breadcrumbs;
		}
	}

}

export interface IChangeApprovalDetailListResult {

	ApprovalLevel: number
	ApprovalBy: number
	ApprovalByUserName: string
	ApprovalDTM: Date
	ApprovalAction: string
	Note: string
}

export class ChangeApprovalDetailListResult implements IChangeApprovalDetailListResult {

	ApprovalLevel: number = 0;
	ApprovalBy: number = 0;
	ApprovalByUserName: string = null;
	ApprovalDTM: Date = new Date(0);
	ApprovalAction: string = null;
	Note: string = null;

	constructor(src?: IChangeApprovalDetailListResult) {
		if (src) {
			this.ApprovalLevel = src.ApprovalLevel;
			this.ApprovalBy = src.ApprovalBy;
			this.ApprovalByUserName = src.ApprovalByUserName;
			this.ApprovalDTM = src.ApprovalDTM;
			this.ApprovalAction = src.ApprovalAction;
			this.Note = src.Note;
		}
	}

}

export interface IListInq {

	Search: string
	StartPage: number
	MaxRows: number
	ShowUnactionable: boolean
	ProposedFromDTM: Date
	ProposedToDTM: Date
}

export class ListInq implements IListInq {

	Search: string = null;
	StartPage: number = null;
	MaxRows: number = null;
	ShowUnactionable: boolean = null;
	ProposedFromDTM: Date = null;
	ProposedToDTM: Date = null;

	constructor(src?: IListInq) {
		if (src) {
			this.Search = src.Search;
			this.StartPage = src.StartPage;
			this.MaxRows = src.MaxRows;
			this.ShowUnactionable = src.ShowUnactionable;
			this.ProposedFromDTM = src.ProposedFromDTM;
			this.ProposedToDTM = src.ProposedToDTM;
		}
	}

}

export interface IChangesListInq {

	SalesEntityID: number
	IncludePending: boolean
	IncludeApproved: boolean
	IncludeDeclined: boolean
	ActionFromDTM: Date
	ActionToDTM: Date
}

export class ChangesListInq implements IChangesListInq {

	SalesEntityID: number = null;
	IncludePending: boolean = false;
	IncludeApproved: boolean = false;
	IncludeDeclined: boolean = false;
	ActionFromDTM: Date = null;
	ActionToDTM: Date = null;

	constructor(src?: IChangesListInq) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.IncludePending = src.IncludePending;
			this.IncludeApproved = src.IncludeApproved;
			this.IncludeDeclined = src.IncludeDeclined;
			this.ActionFromDTM = src.ActionFromDTM;
			this.ActionToDTM = src.ActionToDTM;
		}
	}

}

export interface IChangesListResult {

	TotalRows: number
	ChangeListESP: ChangesList[]
}

export class ChangesListResult implements IChangesListResult {

	TotalRows: number = 0;
	ChangeListESP: ChangesList[] = [];

	constructor(src?: IChangesListResult) {
		if (src) {
			this.TotalRows = src.TotalRows;
			this.ChangeListESP = src.ChangeListESP;
		}
	}

}

export interface IChangesList {

	ChangeID: number
	SalesEntityID: number
	SalesEntityName: string
	SecurableID: number
	SecurableName: string
	OldValue: string
	NewValue: string
	ProposedByUserID: number
	ProposedByUserName: string
	ProposedDTM: Date
	LastActionDTM: Date
	ApprovalStatus: string
	CurrentApprovalLevel: number
	RequiredApprovalLevel: number
	UserApprovalLevel: number
	ChangeAction: string
	ChangeSetID: number
	IsActionable: boolean
	FriendlyName: string
	ObjectDescription: string
	Breadcrumbs: string
}

export class ChangesList implements IChangesList {

	ChangeID: number = 0;
	SalesEntityID: number = 0;
	SalesEntityName: string = null;
	SecurableID: number = 0;
	SecurableName: string = null;
	OldValue: string = null;
	NewValue: string = null;
	ProposedByUserID: number = 0;
	ProposedByUserName: string = null;
	ProposedDTM: Date = new Date(0);
	LastActionDTM: Date = null;
	ApprovalStatus: string = null;
	CurrentApprovalLevel: number = 0;
	RequiredApprovalLevel: number = 0;
	UserApprovalLevel: number = 0;
	ChangeAction: string = null;
	ChangeSetID: number = null;
	IsActionable: boolean = false;
	FriendlyName: string = null;
	ObjectDescription: string = null;
	Breadcrumbs: string = null;

	constructor(src?: IChangesList) {
		if (src) {
			this.ChangeID = src.ChangeID;
			this.SalesEntityID = src.SalesEntityID;
			this.SalesEntityName = src.SalesEntityName;
			this.SecurableID = src.SecurableID;
			this.SecurableName = src.SecurableName;
			this.OldValue = src.OldValue;
			this.NewValue = src.NewValue;
			this.ProposedByUserID = src.ProposedByUserID;
			this.ProposedByUserName = src.ProposedByUserName;
			this.ProposedDTM = src.ProposedDTM;
			this.LastActionDTM = src.LastActionDTM;
			this.ApprovalStatus = src.ApprovalStatus;
			this.CurrentApprovalLevel = src.CurrentApprovalLevel;
			this.RequiredApprovalLevel = src.RequiredApprovalLevel;
			this.UserApprovalLevel = src.UserApprovalLevel;
			this.ChangeAction = src.ChangeAction;
			this.ChangeSetID = src.ChangeSetID;
			this.IsActionable = src.IsActionable;
			this.FriendlyName = src.FriendlyName;
			this.ObjectDescription = src.ObjectDescription;
			this.Breadcrumbs = src.Breadcrumbs;
		}
	}

}

export interface IChgApproval {

	ChangeID: number
	ApprovalAction: string
	Note: string
}

export class ChgApproval implements IChgApproval {

	ChangeID: number = 0;
	ApprovalAction: string = null;
	Note: string = null;

	constructor(src?: IChgApproval) {
		if (src) {
			this.ChangeID = src.ChangeID;
			this.ApprovalAction = src.ApprovalAction;
			this.Note = src.Note;
		}
	}

}

export interface ICompPlanTier {

	CompPlanTierID: number
	CompPlanID: number
	TierThreshold: number
	PriceListID: number
	PriceListName: string
	ContractPercentage: number
	CreatedDateTime: Date
	WriteAll: boolean
	IsApproved: boolean
}

export class CompPlanTier implements ICompPlanTier {

	CompPlanTierID: number = null;
	CompPlanID: number = null;
	TierThreshold: number = null;
	PriceListID: number = null;
	PriceListName: string = null;
	ContractPercentage: number = null;
	CreatedDateTime: Date = null;
	WriteAll: boolean = null;
	IsApproved: boolean = null;

	constructor(src?: ICompPlanTier) {
		if (src) {
			this.CompPlanTierID = src.CompPlanTierID;
			this.CompPlanID = src.CompPlanID;
			this.TierThreshold = src.TierThreshold;
			this.PriceListID = src.PriceListID;
			this.PriceListName = src.PriceListName;
			this.ContractPercentage = src.ContractPercentage;
			this.CreatedDateTime = src.CreatedDateTime;
			this.WriteAll = src.WriteAll;
			this.IsApproved = src.IsApproved;
		}
	}

}

export interface IHistoricalCommission {

	FileID: number
	FileName: string
	FileData: number[]
}

export class HistoricalCommission implements IHistoricalCommission {

	FileID: number = null;
	FileName: string = null;
	FileData: number[] = [];

	constructor(src?: IHistoricalCommission) {
		if (src) {
			this.FileID = src.FileID;
			this.FileName = src.FileName;
			this.FileData = src.FileData;
		}
	}

}

export interface IAffiliateData {

	AffiliateSalesEntityID: number
	AverageBPs: number;
	Description: string;
	Expenses: number;
	Income: number;
	Merchants: number;
	NetIncome: number;
	Payout: number;
	SalesAmount: number;
	TranCount: number;

}

export class AffiliateData implements IAffiliateData {

	AffiliateSalesEntityID: number = null;
	AverageBPs: number = null;
	Description: string = null;
	Expenses: number = null;
	Income: number = null;
	Merchants: number = null;
	NetIncome: number = null;
	Payout: number = null;
	SalesAmount: number = null;
	TranCount: number = null;

	constructor(src?: IAffiliateData) {
		if (src) {
			this.AffiliateSalesEntityID = src.AffiliateSalesEntityID;
			this.AverageBPs = src.AverageBPs;
			this.Description = src.Description;
			this.Expenses = src.Expenses;
			this.Income = src.Income;
			this.Merchants = src.Merchants;
			this.NetIncome = src.NetIncome;
			this.Payout = src.Payout;
			this.SalesAmount = src.SalesAmount;
			this.TranCount = src.TranCount;
		}
	}
}


export interface IMerchantAffiliateData {

	MerchantNumber: number
	DBA: string;
	AverageBPs: number;
	Expenses: number;
	Income: number;
	NetIncome: number;
	Payout: number;
	SalesAmount: number;
	TranCount: number;
}

export class MerchantAffiliateData implements IMerchantAffiliateData {

	MerchantNumber: number = null;
	DBA: string = null;
	AverageBPs: number = null;
	Expenses: number = null;
	Income: number = null;
	NetIncome: number = null;
	Payout: number = null;
	SalesAmount: number = null;
	TranCount: number = null;

	constructor(src?: IMerchantAffiliateData) {
		if (src) {
			this.MerchantNumber = src.MerchantNumber;
			this.DBA = src.DBA;
			this.AverageBPs = src.AverageBPs;
			this.Expenses = src.Expenses;
			this.Income = src.Income;
			this.NetIncome = src.NetIncome;
			this.Payout = src.Payout;
			this.SalesAmount = src.SalesAmount;
			this.TranCount = src.TranCount;
		}
	}
}

export interface IChangeContext {

	ColName: string
	CurrentValue: string
	NewValue: string
	AccessLevel: number
}

export class ChangeContext implements IChangeContext {

	ColName: string = null;
	CurrentValue: string = null;
	NewValue: string = null;
	AccessLevel: number = 0;

	constructor(src?: IChangeContext) {
		if (src) {
			this.ColName = src.ColName;
			this.CurrentValue = src.CurrentValue;
			this.NewValue = src.NewValue;
			this.AccessLevel = src.AccessLevel;
		}
	}

}

export interface ISalesUserCRMAccess {

	SalesEntityID: number
	Name: string
	ContractID: number
	ContractName: string
	CRMInstanceID: number
	CRMUserID: string
}

export class SalesUserCRMAccess implements ISalesUserCRMAccess {

	SalesEntityID: number = 0;
	Name: string = null;
	ContractID: number = 0;
	ContractName: string = null;
	CRMInstanceID: number = 0;
	CRMUserID: string = null;

	constructor(src?: ISalesUserCRMAccess) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.Name = src.Name;
			this.ContractID = src.ContractID;
			this.ContractName = src.ContractName;
			this.CRMInstanceID = src.CRMInstanceID;
			this.CRMUserID = src.CRMUserID;
		}
	}

}

export interface IResidualsDetailAPExportInq {

	SalesEntityID: number
	CommissionsDate: Date
}

export class ResidualsDetailAPExportInq implements IResidualsDetailAPExportInq {

	SalesEntityID: number = 0;
	CommissionsDate: Date = new Date(0);

	constructor(src?: IResidualsDetailAPExportInq) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.CommissionsDate = src.CommissionsDate;
		}
	}

}

export interface IResidualsDetailExportData {

	MID: string
	Region: string
	Prin: string
	Assoc: string
	Chain: string
	DBA: string
	StartBoardDate: Date
	CardRef: string
	ChargeRef: string
	MetricM3: string
	MetricM2: string
	MetricM1: string
	MetricCode: string
	SaleVol: number
	ReturnVol: number
	SaleCnt: number
	ReturnCnt: number
	Income: number
	IntgExpense: number
	DA: number
	BinFee: number
	NetIncome: number
	SharingRate: number
	Payout: number
}

export class ResidualsDetailExportData implements IResidualsDetailExportData {

	MID: string = null;
	Region: string = null;
	Prin: string = null;
	Assoc: string = null;
	Chain: string = null;
	DBA: string = null;
	StartBoardDate: Date = null;
	CardRef: string = null;
	ChargeRef: string = null;
	MetricM3: string = null;
	MetricM2: string = null;
	MetricM1: string = null;
	MetricCode: string = null;
	SaleVol: number = 0;
	ReturnVol: number = 0;
	SaleCnt: number = 0;
	ReturnCnt: number = 0;
	Income: number = 0;
	IntgExpense: number = 0;
	DA: number = 0;
	BinFee: number = 0;
	NetIncome: number = 0;
	SharingRate: number = 0;
	Payout: number = 0;

	constructor(src?: IResidualsDetailExportData) {
		if (src) {
			this.MID = src.MID;
			this.Region = src.Region;
			this.Prin = src.Prin;
			this.Assoc = src.Assoc;
			this.Chain = src.Chain;
			this.DBA = src.DBA;
			this.StartBoardDate = src.StartBoardDate;
			this.CardRef = src.CardRef;
			this.ChargeRef = src.ChargeRef;
			this.MetricM3 = src.MetricM3;
			this.MetricM2 = src.MetricM2;
			this.MetricM1 = src.MetricM1;
			this.MetricCode = src.MetricCode;
			this.SaleVol = src.SaleVol;
			this.ReturnVol = src.ReturnVol;
			this.SaleCnt = src.SaleCnt;
			this.ReturnCnt = src.ReturnCnt;
			this.Income = src.Income;
			this.IntgExpense = src.IntgExpense;
			this.DA = src.DA;
			this.BinFee = src.BinFee;
			this.NetIncome = src.NetIncome;
			this.SharingRate = src.SharingRate;
			this.Payout = src.Payout;
		}
	}

}

export interface IResidualsDetailExport {

	MID: string
	Region: string
	Prin: string
	Assoc: string
	Chain: string
	DBA: string
	StartBoardDate: Date
	CardRef: string
	ChargeRef: string
	MetricM3: string
	MetricM2: string
	MetricM1: string
	MetricCode: string
	SaleVol: number
	ReturnVol: number
	SaleCnt: number
	ReturnCnt: number
	Income: number
	IntgExpense: number
	DA: number
	BinFee: number
	NetIncome: number
	SharingRate: number
	Payout: number
	SalesEntityID: number
	SalesEntityName: string
}

export class ResidualsDetailExport implements IResidualsDetailExport {

	MID: string = null;
	Region: string = null;
	Prin: string = null;
	Assoc: string = null;
	Chain: string = null;
	DBA: string = null;
	StartBoardDate: Date = null;
	CardRef: string = null;
	ChargeRef: string = null;
	MetricM3: string = null;
	MetricM2: string = null;
	MetricM1: string = null;
	MetricCode: string = null;
	SaleVol: number = 0;
	ReturnVol: number = 0;
	SaleCnt: number = 0;
	ReturnCnt: number = 0;
	Income: number = 0;
	IntgExpense: number = 0;
	DA: number = 0;
	BinFee: number = 0;
	NetIncome: number = 0;
	SharingRate: number = 0;
	Payout: number = 0;
	SalesEntityID: number = null;
	SalesEntityName: string = null;

	constructor(src?: IResidualsDetailExport) {
		if (src) {
			this.MID = src.MID;
			this.Region = src.Region;
			this.Prin = src.Prin;
			this.Assoc = src.Assoc;
			this.Chain = src.Chain;
			this.DBA = src.DBA;
			this.StartBoardDate = src.StartBoardDate;
			this.CardRef = src.CardRef;
			this.ChargeRef = src.ChargeRef;
			this.MetricM3 = src.MetricM3;
			this.MetricM2 = src.MetricM2;
			this.MetricM1 = src.MetricM1;
			this.MetricCode = src.MetricCode;
			this.SaleVol = src.SaleVol;
			this.ReturnVol = src.ReturnVol;
			this.SaleCnt = src.SaleCnt;
			this.ReturnCnt = src.ReturnCnt;
			this.Income = src.Income;
			this.IntgExpense = src.IntgExpense;
			this.DA = src.DA;
			this.BinFee = src.BinFee;
			this.NetIncome = src.NetIncome;
			this.SharingRate = src.SharingRate;
			this.Payout = src.Payout;
			this.SalesEntityID = src.SalesEntityID;
			this.SalesEntityName = src.SalesEntityName;
		}
	}

}

export interface IResidualsDetailAPExportData {

	MID: string
	Region: string
	Prin: string
	Assoc: string
	Chain: string
	DBA: string
	StartBoardDate: Date
	CardRef: string
	ChargeRef: string
	MetricM3: string
	MetricM2: string
	MetricM1: string
	MetricCode: string
	SaleVol: number
	ReturnVol: number
	SaleCnt: number
	ReturnCnt: number
	Income: number
	IntgExpense: number
	DA: number
	BinFee: number
	NetIncome: number
	SharingRate: number
	Payout: number
	AgentName: string
	AgentID: string
}

export class ResidualsDetailAPExportData implements IResidualsDetailAPExportData {

	MID: string = null;
	Region: string = null;
	Prin: string = null;
	Assoc: string = null;
	Chain: string = null;
	DBA: string = null;
	StartBoardDate: Date = null;
	CardRef: string = null;
	ChargeRef: string = null;
	MetricM3: string = null;
	MetricM2: string = null;
	MetricM1: string = null;
	MetricCode: string = null;
	SaleVol: number = 0;
	ReturnVol: number = 0;
	SaleCnt: number = 0;
	ReturnCnt: number = 0;
	Income: number = 0;
	IntgExpense: number = 0;
	DA: number = 0;
	BinFee: number = 0;
	NetIncome: number = 0;
	SharingRate: number = 0;
	Payout: number = 0;
	AgentName: string = null;
	AgentID: string = null;

	constructor(src?: IResidualsDetailAPExportData) {
		if (src) {
			this.MID = src.MID;
			this.Region = src.Region;
			this.Prin = src.Prin;
			this.Assoc = src.Assoc;
			this.Chain = src.Chain;
			this.DBA = src.DBA;
			this.StartBoardDate = src.StartBoardDate;
			this.CardRef = src.CardRef;
			this.ChargeRef = src.ChargeRef;
			this.MetricM3 = src.MetricM3;
			this.MetricM2 = src.MetricM2;
			this.MetricM1 = src.MetricM1;
			this.MetricCode = src.MetricCode;
			this.SaleVol = src.SaleVol;
			this.ReturnVol = src.ReturnVol;
			this.SaleCnt = src.SaleCnt;
			this.ReturnCnt = src.ReturnCnt;
			this.Income = src.Income;
			this.IntgExpense = src.IntgExpense;
			this.DA = src.DA;
			this.BinFee = src.BinFee;
			this.NetIncome = src.NetIncome;
			this.SharingRate = src.SharingRate;
			this.Payout = src.Payout;
			this.AgentName = src.AgentName;
			this.AgentID = src.AgentID;
		}
	}

}

export interface ITopSalesEntities {

	SalesEntites: string
	Merchant_Cnt: number
}

export class TopSalesEntities implements ITopSalesEntities {

	SalesEntites: string = null;
	Merchant_Cnt: number = 0;

	constructor(src?: ITopSalesEntities) {
		if (src) {
			this.SalesEntites = src.SalesEntites;
			this.Merchant_Cnt = src.Merchant_Cnt;
		}
	}

}

export interface IMerchOpenNotProcessingInq {

	StartDate: Date
	EndDate: Date
	SalesEntityID: number
	MerchantNumber: number
	DBA: string
	Status: string
	TerminalID: string
	LastBatchDate: Date
	BatchControlNumber: string
	BatchAmount: number
	StartPage: number
	MaxRows: number
	SortColumn: string
	SortOrder: string
}

export class MerchOpenNotProcessingInq implements IMerchOpenNotProcessingInq {

	StartDate: Date = new Date(0);
	EndDate: Date = new Date(0);
	SalesEntityID: number = null;
	MerchantNumber: number = null;
	DBA: string = null;
	Status: string = null;
	TerminalID: string = null;
	LastBatchDate: Date = null;
	BatchControlNumber: string = null;
	BatchAmount: number = null;
	StartPage: number = null;
	MaxRows: number = null;
	SortColumn: string = null;
	SortOrder: string = null;

	constructor(src?: IMerchOpenNotProcessingInq) {
		if (src) {
			this.StartDate = src.StartDate;
			this.EndDate = src.EndDate;
			this.SalesEntityID = src.SalesEntityID;
			this.MerchantNumber = src.MerchantNumber;
			this.DBA = src.DBA;
			this.Status = src.Status;
			this.TerminalID = src.TerminalID;
			this.LastBatchDate = src.LastBatchDate;
			this.BatchControlNumber = src.BatchControlNumber;
			this.BatchAmount = src.BatchAmount;
			this.StartPage = src.StartPage;
			this.MaxRows = src.MaxRows;
			this.SortColumn = src.SortColumn;
			this.SortOrder = src.SortOrder;
		}
	}

}

export interface IMerchOpenNotProcessingResult {
	TotalRows: number
	MerchOnP: MerchOpenNotProcessing[]
}

export class MerchOpenNotProcessingResult implements IMerchOpenNotProcessingResult {

	TotalRows: number = 0;
	MerchOnP: MerchOpenNotProcessing[] = [];

	constructor(src?: IMerchOpenNotProcessingResult) {
		if (src) {
			this.TotalRows = src.TotalRows;
			this.MerchOnP = src.MerchOnP;
		}
	}
}

export interface IMerchOpenNotProcessing {

	MerchantID: string
	MerchantNumber: number
	LegacyMID: number
	SalesEntityName: string
	Status: string
	DBA: string
	DateOpened: Date
	DateClosed: Date
	TerminalID: string
	LastBatchDate: Date
	LastBatchID: number
	BatchControlNumber: string
	BatchAmount: number
}

export class MerchOpenNotProcessing implements IMerchOpenNotProcessing {

	MerchantID: string = null;
	MerchantNumber: number = 0;
	LegacyMID: number = null;
	SalesEntityName: string = null;
	Status: string = null;
	DBA: string = null;
	DateOpened: Date = null;
	DateClosed: Date = null;
	TerminalID: string = null;
	LastBatchDate: Date = null;
	LastBatchID: number = null;
	BatchControlNumber: string = null;
	BatchAmount: number = null;

	constructor(src?: IMerchOpenNotProcessing) {
		if (src) {
			this.MerchantID = src.MerchantID;
			this.MerchantNumber = src.MerchantNumber;
			this.LegacyMID = src.LegacyMID;
			this.SalesEntityName = src.SalesEntityName;
			this.Status = src.Status;
			this.DBA = src.DBA;
			this.DateOpened = src.DateOpened;
			this.DateClosed = src.DateClosed;
			this.TerminalID = src.TerminalID;
			this.LastBatchDate = src.LastBatchDate;
			this.LastBatchID = src.LastBatchID;
			this.BatchControlNumber = src.BatchControlNumber;
			this.BatchAmount = src.BatchAmount;
		}
	}

}

export interface IProcessingResultDetailsInq {

	SalesEntityID: number
	FilterType: number
	StartPage: number
	MaxRows: number
	MaxRecords: number
	SortColumn: string
	SortOrder: string
	isExport: boolean
}

export class ProcessingResultDetailsInq implements IProcessingResultDetailsInq {
	SalesEntityID: number = null;
	FilterType: number = null;
	StartPage: number = null;
	MaxRows: number = null;
	MaxRecords: number = null;
	SortColumn: string = null;
	SortOrder: string = null;
	isExport: boolean = null;

	constructor(src?: IProcessingResultDetailsInq) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.FilterType = src.FilterType;
			this.StartPage = src.StartPage;
			this.MaxRows = src.MaxRows;
			this.MaxRecords = src.MaxRecords;
			this.SortColumn = src.SortColumn;
			this.SortOrder = src.SortOrder;
			this.isExport = src.isExport;
		}
	}
}

export interface IProcessingResultDetailsPaging {
	ProcessingResultDetails: ProcessingResultDetails[]
	TotalRows: number
}

export class ProcessingResultDetailsPaging implements IProcessingResultDetailsPaging {
	ProcessingResultDetails: ProcessingResultDetails[] = [];
	TotalRows: number = 0;

	constructor(src?: IProcessingResultDetailsPaging) {
		if (src) {
			this.ProcessingResultDetails = src.ProcessingResultDetails;
			this.TotalRows = src.TotalRows;
		}
	}
}



export interface IProcessingResultDetails {
	MerchantID: string
	DBA: string
	CurrentStatus: string
	DateLastProcessed: Date
	MTD_Volume: number
	MTD_Transactions: number
	Prior_MTD_Volume: number
	Prior_MTD_Transactions: number
	YTD_Volume: number
	YTD_Transactions: number
	Prior_YTD_Volume: number
	Prior_YTD_Transactions: number
}

export class ProcessingResultDetails implements IProcessingResultDetails {

	MerchantID: string
	DBA: string
	CurrentStatus: string
	DateLastProcessed: Date
	MTD_Volume: number
	MTD_Transactions: number
	Prior_MTD_Volume: number
	Prior_MTD_Transactions: number
	YTD_Volume: number
	YTD_Transactions: number
	Prior_YTD_Volume: number
	Prior_YTD_Transactions: number

	constructor(src?: IProcessingResultDetails) {
		if (src) {
			this.MerchantID = src.MerchantID
			this.DBA = src.DBA
			this.CurrentStatus = src.CurrentStatus
			this.DateLastProcessed = src.DateLastProcessed
			this.MTD_Volume = src.MTD_Volume
			this.MTD_Transactions = src.MTD_Transactions
			this.Prior_MTD_Volume = src.Prior_MTD_Volume
			this.Prior_MTD_Transactions = src.Prior_MTD_Transactions
			this.YTD_Volume = src.YTD_Volume
			this.YTD_Transactions = src.YTD_Transactions
			this.Prior_YTD_Volume = src.Prior_YTD_Volume
			this.Prior_YTD_Transactions = src.Prior_YTD_Transactions
		}
	}

}

/**TODO: INSTALLATIONS */

export interface IInstallationsDetailsInq {
	FilterType: number;
	StartPage: number;
	MaxRows: number;
	MaxRecords: number;
	SortBy: string;
	SortOrder: string;
	isExport: boolean;
	MTD: boolean;
	Installed: boolean;

}

export class InstallationsDetailsInq implements IInstallationsDetailsInq {

	MaxRows: number;
	StartPage: number;
	FilterType: number;
	isExport: boolean;
	MTD: boolean;
	Installed: boolean;
	SortBy: string;
	SortOrder: string;
	MaxRecords: number;

	constructor(src?: IInstallationsDetailsInq) {
		if (src) {
			this.FilterType = src.FilterType;
			this.StartPage = src.StartPage;
			this.MaxRows = src.MaxRows;
			this.MaxRecords = src.MaxRecords;
			this.SortBy = src.SortBy;
			this.SortOrder = src.SortOrder;
			this.isExport = src.isExport;
			this.MTD = src.MTD;
			this.Installed = src.Installed;
		}
	}
}

export interface IInstallationsDetailsPaging {
	InstallationsReportList: InstallationsDetails[]
	TotalRows: number
}

export class InstallationsDetailsPaging implements IInstallationsDetailsPaging {
	InstallationsReportList: InstallationsDetails[] = [];
	TotalRows: number = 0;

	constructor(src?: IInstallationsDetailsPaging) {
		if (src) {
			this.InstallationsReportList = src.InstallationsReportList;
			this.TotalRows = src.TotalRows;
		}
	}
}


export interface IInstallationsDetails {
	DBA: string;
	A360Mid: string;
	InstallDate?: Date;
	LegacyMid?: number;
	InstalledStatus: string;
	SalesEntityName: string;
	DateOpened? : Date;
}

export class InstallationsDetails implements IInstallationsDetails {
8
		DBA: string;
		A360Mid: string;
		InstallDate?: Date = null;
		LegacyMid?: number;
		InstalledStatus: string;
		SalesEntityName: string;
		DateOpened? : Date = null;

	constructor(src?: IInstallationsDetails) {
		if (src) {
			this.DBA = src.DBA;
			this.A360Mid = src.A360Mid;
			this.InstallDate = src.InstallDate;
			this.LegacyMid = src.LegacyMid;
			this.InstalledStatus = src.InstalledStatus;
			this.SalesEntityName = src.SalesEntityName;
			this.DateOpened = src.DateOpened;
		}
	}

}

/** */



export interface IResSummaryByMerchInq {

	SalesEntityID: number
	CommissionsDate: Date
}

export class ResSummaryByMerchInq implements IResSummaryByMerchInq {

	SalesEntityID: number = 0;
	CommissionsDate: Date = new Date(0);

	constructor(src?: IResSummaryByMerchInq) {
		if (src) {
			this.SalesEntityID = src.SalesEntityID;
			this.CommissionsDate = src.CommissionsDate;
		}
	}

}

export interface IResidualsSummaryByMerchantExportRec {

	MerchantID: string
	CategoryName: string
	M3_Name: string
	M2_Name: string
	M1_Name: string
	MetricCode: string
	CardRef: string
	ChargeRef: string
	SalesAmount: number
	TranCount: number
	Income: number
	Expenses: number
	NetIncome: number
	Payout: number
}

export class ResidualsSummaryByMerchantExportRec implements IResidualsSummaryByMerchantExportRec {

	MerchantID: string = null;
	CategoryName: string = null;
	M3_Name: string = null;
	M2_Name: string = null;
	M1_Name: string = null;
	MetricCode: string = null;
	CardRef: string = null;
	ChargeRef: string = null;
	SalesAmount: number = null;
	TranCount: number = null;
	Income: number = null;
	Expenses: number = null;
	NetIncome: number = null;
	Payout: number = null;

	constructor(src?: IResidualsSummaryByMerchantExportRec) {
		if (src) {
			this.MerchantID = src.MerchantID;
			this.CategoryName = src.CategoryName;
			this.M3_Name = src.M3_Name;
			this.M2_Name = src.M2_Name;
			this.M1_Name = src.M1_Name;
			this.MetricCode = src.MetricCode;
			this.CardRef = src.CardRef;
			this.ChargeRef = src.ChargeRef;
			this.SalesAmount = src.SalesAmount;
			this.TranCount = src.TranCount;
			this.Income = src.Income;
			this.Expenses = src.Expenses;
			this.NetIncome = src.NetIncome;
			this.Payout = src.Payout;
		}
	}

}

export interface IResidualsDetailISO {

	MID: string
	ISOID: string
	ISOName: string
	AgentID: string
	AgentName: string
	AffiliateNumber: string
	AffiliateRoleName: string
	AffiliateRecruiter: string
	DBA: string
	StartBoardDate: Date
	CardRef: string
	ChargeRef: string
	MetricM3: string
	MetricM2: string
	MetricM1: string
	MetricCode: string
	SaleVol: number
	ReturnVol: number
	SaleCnt: number
	ReturnCnt: number
	Income: number
	IntgExpense: number
	DA: number
	BinFee: number
	NetIncome: number
	SharingRate: number
	Payout: number
}

export class ResidualsDetailISO implements IResidualsDetailISO {

	MID: string = null;
	ISOID: string = null;
	ISOName: string = null;
	AgentID: string = null;
	AgentName: string = null;
	AffiliateNumber: string = null;
	AffiliateRoleName: string = null;
	AffiliateRecruiter: string = null;
	DBA: string = null;
	StartBoardDate: Date = null;
	CardRef: string = null;
	ChargeRef: string = null;
	MetricM3: string = null;
	MetricM2: string = null;
	MetricM1: string = null;
	MetricCode: string = null;
	SaleVol: number = null;
	ReturnVol: number = null;
	SaleCnt: number = null;
	ReturnCnt: number = null;
	Income: number = null;
	IntgExpense: number = null;
	DA: number = null;
	BinFee: number = null;
	NetIncome: number = null;
	SharingRate: number = null;
	Payout: number = null;

	constructor(src?: IResidualsDetailISO) {
		if (src) {
			this.MID = src.MID;
			this.ISOID = src.ISOID;
			this.ISOName = src.ISOName;
			this.AgentID = src.AgentID;
			this.AgentName = src.AgentName;
			this.AffiliateNumber = src.AffiliateNumber;
			this.AffiliateRoleName = src.AffiliateRoleName;
			this.AffiliateRecruiter = src.AffiliateRecruiter;
			this.DBA = src.DBA;
			this.StartBoardDate = src.StartBoardDate;
			this.CardRef = src.CardRef;
			this.ChargeRef = src.ChargeRef;
			this.MetricM3 = src.MetricM3;
			this.MetricM2 = src.MetricM2;
			this.MetricM1 = src.MetricM1;
			this.MetricCode = src.MetricCode;
			this.SaleVol = src.SaleVol;
			this.ReturnVol = src.ReturnVol;
			this.SaleCnt = src.SaleCnt;
			this.ReturnCnt = src.ReturnCnt;
			this.Income = src.Income;
			this.IntgExpense = src.IntgExpense;
			this.DA = src.DA;
			this.BinFee = src.BinFee;
			this.NetIncome = src.NetIncome;
			this.SharingRate = src.SharingRate;
			this.Payout = src.Payout;
		}
	}

}

export interface IDailyResidualsResponse {

	DailyResiduals: number[]
}

export class DailyResidualsResponse implements IDailyResidualsResponse {

	DailyResiduals: number[] = [];

	constructor(src?: IDailyResidualsResponse) {
		if (src) {
			this.DailyResiduals = src.DailyResiduals;
		}
	}

}

export interface IResidualsOutlookResponse {

	TotalPayout: number
	PayChange: number
	TotalPerM: number
	PerMChange: number
	ResOutlook: ResidualsOutlook[]
}

export class ResidualsOutlookResponse implements IResidualsOutlookResponse {

	TotalPayout: number = 0;
	PayChange: number = 0;
	TotalPerM: number = 0;
	PerMChange: number = 0;
	ResOutlook: ResidualsOutlook[] = [];

	constructor(src?: IResidualsOutlookResponse) {
		if (src) {
			this.TotalPayout = src.TotalPayout;
			this.PayChange = src.PayChange;
			this.TotalPerM = src.TotalPerM;
			this.PerMChange = src.PerMChange;
			this.ResOutlook = src.ResOutlook;
		}
	}

}

export interface IResidualsOutlook {

	CommissionsDate: Date
	TotalRes: number
}

export class ResidualsOutlook implements IResidualsOutlook {

	CommissionsDate: Date = new Date(0);
	TotalRes: number = 0;

	constructor(src?: IResidualsOutlook) {
		if (src) {
			this.CommissionsDate = src.CommissionsDate;
			this.TotalRes = src.TotalRes;
		}
	}

}

export interface IMerchantEquipment {
	sHostMode: string;
	sNetwork: string;
	sDownloadID: string;
	iSequence: number;
	sTerminal: string;
	sPrinter: string;
	sPinpad: string;
	sTerminalID: string;
	sAutoCloseTime: Date;
	sSerialTerminal: string;
	sSerialPinPad: string;
	sSerialPrinter: string;
	sTracking: string;
}

export class MerchantEquipment implements IMerchantEquipment {
	sHostMode: string = null;
	sNetwork: string = null;
	sDownloadID: string = null;
	iSequence: number = 0;
	sTerminal: string = null;
	sPrinter: string = null;
	sPinpad: string = null;
	sTerminalID: string = null;
	sAutoCloseTime: Date = null;
	sSerialTerminal: string = null;
	sSerialPinPad: string = null;
	sSerialPrinter: string = null;
	sTracking: string = null;

	constructor(src?: IMerchantEquipment) {
		if (src) {
			this.sHostMode = src.sHostMode;
			this.sNetwork = src.sNetwork;
			this.sDownloadID = src.sDownloadID;
			this.iSequence = src.iSequence;
			this.sTerminal = src.sTerminal;
			this.sPrinter = src.sPrinter;
			this.sPinpad = src.sPinpad;
			this.sTerminalID = src.sTerminalID;
			this.sAutoCloseTime = src.sAutoCloseTime;
			this.sSerialTerminal = src.sSerialTerminal;
			this.sSerialPinPad = src.sSerialPinPad;
			this.sSerialPrinter = src.sSerialPrinter;
			this.sTracking = src.sTracking;
		}
	}
}

export interface IResidualsAgentSummary {
	Month: Date;
	TotalMIDs: number;
	SalesVolume: number;
	Items: number;
	AvgTicket: number;
	Income: number;
	Expenses: number;
	GRP: number;
	Payout: number;
	AgentID: number;
	AgentName: string;
}

export class ResidualsAgentSummary implements IResidualsAgentSummary {
	Month: Date = new Date(0);
	TotalMIDs: number = 0;
	SalesVolume: number = 0;
	Items: number = 0;
	AvgTicket: number = 0;
	Income: number = 0;
	Expenses: number = 0;
	GRP: number = 0;
	Payout: number = 0;
	AgentID: number = 0;
	AgentName: string = null;

	/**
	 *
	 */
	constructor(src? : IResidualsAgentSummary) {
		if(src) {
			this.Month = src.Month;
			this.TotalMIDs = src.TotalMIDs;
			this.SalesVolume = src.SalesVolume;
			this.Items = src.Items;
			this.AvgTicket = src.AvgTicket;
			this.Income = src.Income;
			this.Expenses = src.Expenses;
			this.GRP = src.GRP;
			this.Payout = src.Payout;
			this.AgentID = src.AgentID;
			this.AgentName = src.AgentName;
		}
	}
}
/**
 * Stop, do not add to this file
 * This file is autogenerated using the typewriter TypescriptGenerator project in SalesEntityAPI
 * Make your own ts file if you didn't autogenerate this file.
 */


